// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:34:06.356Z
// Property: Remington Wichita Apts. (ID: 6767906449166548)
// Collections: 24 amenities, 4 floorplans (live), 37 photos, 76 POIs, 3 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449166548",
  "property_external_id": "48299",
  "property_zillow_url": "https://www.zillow.com/apartments/wichita-ks/remington-wichita-apts./5ZbX2Q/",
  "property_apartments_url": "https://www.apartments.com/7272-e-37th-st-n-wichita-ks-unit-0210780789/x7lqkjq/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Remington+Apartments/data=!4m2!3m1!1s0x0:0x28bfe496b83d9116?sa=X&ved=2ahUKEwiWyLWvhL2SAxXZEVkFHRGyEn4Q_BJ6BAgREAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "remington-wichita-apts.",
  "property_name": "Remington Wichita Apts.",
  "property_website_url": "https://www.caseusa.com/apartments/ks/wichita/the-remington/",
  "property_domain": null,
  "property_address": "7272 East 37th Street North",
  "property_full_address": "7272 East 37th Street North, Wichita, KS, 67226",
  "property_address_1": "7272 East 37th Street North",
  "property_address_2": null,
  "property_address_city": "Wichita",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "67226",
  "property_address_country": "US",
  "property_address_county": "Sedgwick County",
  "property_neighborhood_address": "Northeast Wichita",
  "property_address_latitude": "37.7527",
  "property_address_longitude": "-97.2526",
  "property_email": "theremington@caseusa.com",
  "property_phone": "(316) 800-9797",
  "property_call_tracking_phone": "844-689-0716",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Remington Wichita, comfort and convenience unite in spacious one and two-bedroom apartments. Enjoy our pet-friendly amenities, including a stunning outdoor pool, BBQ picnic area, and 24-hour fitness center. With easy access to K-96 and I-35, your ideal home is just a click away. Schedule your tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Remington Wichita, your ideal apartment community in the heart of Wichita, KS. Offering spacious one and two-bedroom floor plans, our homes are designed with your comfort and lifestyle in mind. Each apartment features essentials such as fully equipped kitchens, large closets, and option upgrades like wood-burning fireplaces and ceiling fans for that extra touch of home.\n\nEmbrace the perfect blend of relaxation and convenience with our exceptional amenities. Enjoy summer days lounging by our outdoor swimming pool or hosting a fun BBQ in our picnic area. For those balancing work and play, our business center and 24-hour fitness center ensure you can stay productive and healthy without leaving home. Plus, our pet-friendly community means your furry friends are welcome to join you!\n\nExperience peace of mind with our 24-hour emergency maintenance and hassle-free features like online rental payments and flexible payment options. Located conveniently near K-96 and I-35, you’ll have easy access to the best that Wichita has to offer. Our professional management team is dedicated to providing you with outstanding service in your new home.\n\nWhether you’re looking to entertain guests on your private patio or balcony or need the convenience of laundry facilities and package receiving, Remington Wichita has it all. Plus, stay connected with super-fast internet powered by AT&T, making remote work or streaming your favorite shows a breeze.\n\nFind your new home today—browse our availability or schedule a tour to visit our remarkable community! Discover the vibrant lifestyle waiting for you at Remington Wichita!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfdaa-63d5-727b-b70c-27d4c59068ed.webp",
  "property_featured_image_media": {
    "alt_text": "Apartment building exterior with a large swimming pool and lounge chairs.",
    "public_id": "019cfdaa-63d5-727b-b70c-27d4c59068ed",
    "storage_key": "property/6767906449166548/019cfdaa-63d5-727b-b70c-27d4c59068ed.webp",
    "width": 2700,
    "height": 1800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Cats and dogs allowed (breed restrictions apply). Maximum of 2 pets per apartment.",
  "property_pet_policy_description": "Cats and dogs allowed. Maximum of two pets per apartment. Pet rent is $30 per pet per month. Non‑refundable pet fee equal to half a month’s rent per pet. Breed restrictions apply.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://remingtonapartmentswichita.securecafe.com/onlineleasing/remington-wichita-apts/floorplans.aspx",
  "property_resident_portal_url": "https://remingtonapartmentswichita.securecafe.com/residentservices/remington-wichita-apts/userlogin.aspx",
  "property_apply_now_url": "https://remingtonapartmentswichita.securecafe.com/onlineleasing/remington-wichita-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-0427-7367-9815-5230564ef8b4.webp",
  "property_primary_logo_media": {
    "alt_text": "The Remington apartment homes logo",
    "public_id": "019cfb4f-0427-7367-9815-5230564ef8b4",
    "storage_key": "property/6767906449166548/019cfb4f-0427-7367-9815-5230564ef8b4.webp",
    "width": 792,
    "height": 352
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-abbc-745c-8932-76145eac25b4.webp",
  "property_secondary_logo_media": {
    "alt_text": "Black and white image of a generic apartment building exterior.",
    "public_id": "019cfb4f-abbc-745c-8932-76145eac25b4",
    "storage_key": "property/6767906449166548/019cfb4f-abbc-745c-8932-76145eac25b4.webp",
    "width": 5,
    "height": 5
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-0427-7367-9815-5230564ef8b4.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Remington apartment homes logo",
    "public_id": "019cfb4f-0427-7367-9815-5230564ef8b4",
    "storage_key": "property/6767906449166548/019cfb4f-0427-7367-9815-5230564ef8b4.webp",
    "width": 792,
    "height": 352
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-cd93-7392-aef0-84612e5145e3.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Remington Apartment Homes logo",
    "public_id": "019cfb4f-cd93-7392-aef0-84612e5145e3",
    "storage_key": "property/6767906449166548/019cfb4f-cd93-7392-aef0-84612e5145e3.webp",
    "width": 640,
    "height": 284
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": null,
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "738 - 978",
  "property_sqft_min": "738",
  "property_sqft_max": "978",
  "property_price_range": "1004 - 1209",
  "property_price_min": "1004",
  "property_price_max": "1209",
  "property_available_units": 11,
  "property_facebook_url": "https://www.facebook.com/theremingtonkansas/posts/experience-cozy-comfort-in-your-new-1-bedroom-apartment-featuring-a-charming-woo/1490201929579566/",
  "property_instagram_url": "https://www.instagram.com/remingtonwichita/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJJ1e5TVj9uocRFpE9uJbkvyg",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/the-remington-apartments-wichita-2",
  "property_tiktok_url": "https://www.tiktok.com/@remingtonwichita",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Remington Wichita ",
  "property_home_romance_title": "Embrace the Charm of Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Remington Wichita, where modern living meets comfort and convenience in the heart of Wichita, KS. Choose from spacious one- and two-bedroom floor plans equipped with everything you need. Unwind by the outdoor swimming pool, enjoy our pet-friendly atmosphere, or stay productive in the business center. Join our vibrant community today!",
  "property_home_floorplans_blurb": "Welcome to Remington Wichita, where comfort meets style in the heart of Wichita, KS. Choose from our thoughtfully designed one and two-bedroom floor plans, each tailored to elevate your living experience. Browse our available apartment homes today and find the perfect space that feels just like home.",
  "property_home_gallery_blurb": "At Remington Wichita, your new home awaits! Choose from spacious one and two-bedroom floor plans, each featuring fully equipped kitchens and large closets. Enjoy vibrant amenities like a pool, BBQ area, and a pet-friendly vibe. With 24-hour fitness and professional management, picture yourself living here—where comfort meets convenience.",
  "property_home_neighborhood_blurb": "At Remington Wichita, your new home offers spacious one and two-bedroom apartments amid vibrant community attractions. Dive into local culture with nearby gems like the Museum of World Treasures, Woolsey Hall, and The Great Plains Nature Center. Embrace a lifestyle filled with excitement and convenience just outside your door!",
  "property_home_reviews_blurb": "At Remington Wichita, our residents have spoken: “This is literally the best place I’ve ever lived!” With beautiful, clean apartments, a welcoming atmosphere, and a dedicated maintenance team, our community feels like home. Join us and experience the kindness that makes Remington truly special. See what our residents have to say! ",
  "property_neighborhood_blurb": "At Remington Wichita, you’re immersed in a vibrant neighborhood. Within minutes, enjoy the dynamic charm of Wichita State University, the cultural richness of the Museum of World Treasures, or the serene beauty of Fairmount Park. See what surrounds our community and uncover local favorites nestled nearby!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Remington Wichita, your lifestyle is enhanced by spacious one and two-bedroom floor plans and an array of exceptional amenities. Enjoy a refreshing dip in our outdoor pool, unwind in our BBQ area, or stay active in the 24-hour fitness center—all in a pet-friendly environment tailored just for you!",
  "property_applynow_blurb": "At Remington Wichita, your ideal living space awaits in the heart of Wichita, KS. Choose from spacious one and two-bedroom floor plans featuring modern kitchens and cozy fireplaces. Enjoy our inviting BBQ area, outdoor pool, and 24-hour fitness center. Apply now and embrace the lifestyle you deserve!",
  "property_contactus_blurb": "At Remington Wichita, we offer thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Nestled in the heart of Wichita, KS, these spacious layouts blend comfort and modern living. Have questions? Our leasing team is ready to assist you—get in touch today!",
  "property_faqs_blurb": "At Remington Wichita, our thoughtfully designed floor plans include stylish one and two-bedroom apartments that cater to your lifestyle. Have questions about our vibrant community? Dive into our FAQs page for insights and discover how Remington Wichita can be your ideal home in the heart of Wichita, KS.",
  "property_floorplans_blurb": "At Remington Wichita, each apartment home is designed with your lifestyle in mind. Whether you seek the cozy charm of a one-bedroom or the spacious comfort of a two-bedroom, our thoughtfully crafted floor plans cater to your every need. Browse now and envision your new beginning in Wichita!",
  "property_gallery_blurb": "At Remington Wichita, our spacious one- and two-bedroom floor plans offer the perfect blend of comfort and convenience. Imagine relaxing by the outdoor pool, or hosting friends in the BBQ area. With professional management and pet-friendly amenities, your ideal lifestyle awaits. Picture yourself living here!",
  "property_interactivemap_blurb": "Welcome to Remington Wichita, where modern living meets convenience. Choose from spacious one- and two-bedroom floor plans featuring fully equipped kitchens, patios, and pet-friendly amenities. Enjoy our outdoor pool, 24-hour fitness center, and professional management. Use our interactive community map to find your perfect apartment in Wichita, KS!",
  "property_pets_blurb": "At Remington Wichita, your furry friends are part of the family! Enjoy spacious apartments with a welcoming environment for cats and dogs, where your pets can thrive. With our thoughtful pet policy and ample green spaces, both you and your pets will feel right at home in beautiful Wichita, KS.",
  "property_referafriend_blurb": "At Remington Wichita, we believe that great friends make great neighbors! Our inviting one and two-bedroom floor plans cater to diverse lifestyles, ensuring your perfect home awaits. Refer a friend to our vibrant community in Wichita, KS, and enjoy the perks of shared living today! Your ideal apartment is just a referral away!",
  "property_residentaccess_blurb": "At Remington Wichita, your ideal home awaits with thoughtfully designed one- and two-bedroom floor plans tailored to your lifestyle. Enhance your living experience in beautiful Wichita, KS. Access your resident portal to conveniently pay rent, schedule maintenance, and stay connected with your community today!",
  "property_reviews_blurb": "At Remington Wichita, our residents express their joy in calling us home, raving about our \"friendly and welcoming\" community. With beautifully maintained 2-bedroom apartments, spacious living areas, and a dedicated staff that ensures safety and comfort, you’ll find a place where exceptional living meets heartfelt care. See what our residents have to say about living at our community!",
  "property_created_at": "1759851414791",
  "property_scheduletour_blurb": "At Remington Wichita, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Nestled in vibrant Wichita, KS, our community invites you to immerse yourself in modern living. Curious about life here? Check out resident testimonials and envision your new home!",
  "property_thankyou_blurb": "Thank you for reaching out to Remington Wichita! With our spacious one and two-bedroom floor plans, you'll find the perfect home to suit your lifestyle. Our dedicated team will be in touch shortly to assist you in discovering the vibrant living experience that awaits you in Wichita, KS.",
  "property_virtualtours_blurb": "Step into your future at Remington Wichita, where modern comfort meets spacious living in our elegant one and two-bedroom apartments. Nestled in vibrant Wichita, KS, each space is designed with you in mind. Ready to find your ideal home? Take a virtual tour of our community and apartments for rent today!",
  "property_copyright": "2025 All Rights Reserved. Remington Wichita ",
  "property_seo_title_home": "Remington Wichita  |  Apartments in Wichita, KS",
  "property_seo_description_home": "Experience vibrant living at Remington Wichita! Enjoy spacious apartments, modern amenities, and a pet-friendly environment—just minutes from K-96 and I-35!",
  "property_seo_title_floorplans": "Floor Plans | Wichita, KS Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Remington Wichita! Choose from spacious one and two-bedroom floor plans designed for comfort and style in the heart of Wichita, KS.",
  "property_seo_title_amenities": "Amenities | Wichita, KS Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Remington Wichita! Enjoy spacious one and two-bedroom apartments, a pet-friendly environment, and amenities like a pool, gym, and BBQ area.",
  "property_seo_title_gallery": "Gallery | Apartments in Wichita, KS",
  "property_seo_description_gallery": "Imagine life at Remington Wichita! Enjoy spacious floor plans, a refreshing pool, and pet-friendly perks in cozy apartments. View the photo gallery now!",
  "property_seo_title_virtualtours": "Virtual Tours | Remington Wichita  Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Remington Wichita! Take a virtual tour of our one- and two-bedroom apartments and find your perfect home in vibrant Wichita, KS.",
  "property_seo_title_interactivemap": "Interactive Map | Remington Wichita  Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Remington Wichita! Dive into spacious floor plans, pet-friendly amenities, and a vibrant community. Use our interactive map today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Wichita, KS",
  "property_seo_description_neighborhood": "Uncover Wichita's hidden gems around Remington Wichita. From local favorites to vibrant hotspots, see what makes our neighborhood a prime spot to call home!",
  "property_seo_title_contact": "Contact Us | Remington Wichita ",
  "property_seo_description_contact": "Connect with Remington Wichita! Our one & two-bedroom apartments await your visit. Have questions? Reach out to our friendly leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Wichita, KS",
  "property_seo_description_faqs": "Find everything you need at Remington Wichita! From spacious floor plans to top-notch amenities, our FAQs page has the answers to help you settle in.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Wichita, KS",
  "property_seo_description_reviews": "Join our vibrant community at Remington Wichita! Check out resident reviews and see why our spacious apartments with top-notch amenities make home special.",
  "property_seo_title_applynow": "Apply Now | Apartments in Wichita, KS",
  "property_seo_description_applynow": "Unwind in spacious one and two-bedroom apartments at Remington Wichita. Enjoy pet-friendly living, a pool, and 24/7 amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Remington Wichita ",
  "property_seo_description_residentaccess": "Log into your Remington Wichita resident portal for seamless rent payments, maintenance requests, and community updates. Your comfort is just a click away!",
  "property_seo_title_referafriend": "Refer A Friend | Remington Wichita ",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Remington Wichita and enjoy a vibrant community in Wichita, KS. Share the love today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Remington Wichita ",
  "property_seo_description_scheduletour": "Experience the charm of Remington Wichita! Book your tour today to see modern living spaces and vibrant community amenities in the heart of Wichita, KS.",
  "property_seo_title_privacy": "Privacy Policy | Remington Wichita ",
  "property_seo_description_privacy": "Your privacy matters at Remington Wichita. Uncover how we protect your information and provide a secure living experience. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Remington Wichita ",
  "property_seo_description_accessibility": "At Remington Wichita, we promote digital inclusion with accessibility features, ensuring everyone feels at home in our vibrant community.",
  "property_seo_title_sitemap": "Sitemap | Remington Wichita ",
  "property_seo_description_sitemap": "Explore Remington Wichita! View our sitemap for a seamless guide to our vibrant community and amenities in beautiful Wichita, KS.",
  "property_seo_title_thankyou": "Thank You | Remington Wichita ",
  "property_seo_description_thankyou": "Thank you for reaching out! Our team at Remington Wichita is excited to connect with you soon about your future home in vibrant Wichita, KS. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Wichita, KS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865704518",
  "amenities": [
    {
      "id": "ec_c661a01b9d25374f90bb110b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127397066",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d440af8035c53a7e3f1c88a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127397067",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2098c04de85f281daaec6802",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127397068",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f7e7d566b92350e07360f69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127397069",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7d6c4d06b0424c9fee5c49b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127397070",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8040e93bf3f633938946d8be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127397071",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73082539751b85d69548e245",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127397072",
      "title": "Outdoor Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_60e92c8a9a72878315365e93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127397073",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3f28d04c6aa12649d992fe0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127397074",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_126119f99bc6131ff86c7bca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127397075",
      "title": "Close to K-96 and I-35",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ccf412e93e192b0b22290fe1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127397076",
      "title": "Professional Management Team",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9fdffbe76a5a74bd418ec2e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "128042518",
      "title": "AT&T",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fec0c50a97ae6dfe1cc9cf8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127397077",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d41043216b58b3d0dd2c2320",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "128087120",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4898dd0b9b6962e5f7731b9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127398527",
      "title": "Fully Equipped Kitchens",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e700ee27a4b2165f64e5185",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127398528",
      "title": "Ceiling Fan*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c6d1a2f61370a2affb7dc41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127398529",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a836ec3cf6030dd50ddd3d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127398530",
      "title": "Extra Storage*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c88edecc665b73db284aa136",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127398531",
      "title": "Wood Burning Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_18d280de64b42372eba7db58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127398532",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5fb0e01104cc82f91da0cfc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127398533",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f50aa15d08393aa2fa01ef17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127398534",
      "title": "Full-Size Washer/Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_99ddc2e1e03c142598416ac0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127398535",
      "title": "Spacious Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a28a21c5e591735d06180d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "yardi",
      "external_id": "127398536",
      "title": "Get Connected To Super-Fast Internet Powered by AT&T",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_ef0a45e8-c7e4-43a2-ae38-30682367d466",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-5727-758c-b0f2-fb5630c29b92.webp",
      "image_media": {
        "alt_text": "Brick entrance sign for The Remington apartment homes with blue buildings in the background.",
        "public_id": "019d270c-5727-758c-b0f2-fb5630c29b92",
        "storage_key": "property/6767906449166548/019d270c-5727-758c-b0f2-fb5630c29b92.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior view of The Remington apartment community, featuring the brick entry sign and surrounding buildings and landscaping.",
      "link": "",
      "alt_text": "Brick entrance sign for The Remington apartment homes with blue buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-b5fa-719d-9c18-f554b5ba363f.webp"
    },
    {
      "id": "custom_6c7ceaaa-185e-4f66-8dd0-b45249a11fb8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-5715-70fb-b524-fdd45d5d76ba.webp",
      "image_media": {
        "alt_text": "Front entrance of a blue apartment community building with a gate, pillars, and manicured lawn.",
        "public_id": "019d270c-5715-70fb-b524-fdd45d5d76ba",
        "storage_key": "property/6767906449166548/019d270c-5715-70fb-b524-fdd45d5d76ba.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment community with gated entrance, signage, and landscaping.",
      "link": "",
      "alt_text": "Front entrance of a blue apartment community building with a gate, pillars, and manicured lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-b5bd-700d-a7de-4caf0392b316.webp"
    },
    {
      "id": "custom_39439e67-724b-4118-9257-37197ec76fc9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-5748-7569-8972-0808321a0cef.webp",
      "image_media": {
        "alt_text": "Exterior view of a blue apartment building with a manicured lawn and pool in the background.",
        "public_id": "019d270c-5748-7569-8972-0808321a0cef",
        "storage_key": "property/6767906449166548/019d270c-5748-7569-8972-0808321a0cef.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior of a blue multifamily community featuring landscaped grounds and a pool area.",
      "link": "",
      "alt_text": "Exterior view of a blue apartment building with a manicured lawn and pool in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-ccc1-77b9-85eb-5d5459cc76d2.webp"
    },
    {
      "id": "custom_7ee7924a-a6b7-4feb-930d-52f2baf56bf4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-5762-74cf-8b98-ad59b4e6aa27.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-building apartment complex with balconies and a curved walkway.",
        "public_id": "019d270c-5762-74cf-8b98-ad59b4e6aa27",
        "storage_key": "property/6767906449166548/019d270c-5762-74cf-8b98-ad59b4e6aa27.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "A modern apartment community featuring stacked balconies, well-kept lawns, and a central pedestrian path.",
      "link": "",
      "alt_text": "Exterior view of a multi-building apartment complex with balconies and a curved walkway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449166548/019cfb4f-0ebd-749e-8bbb-0d9b08db9f34.webp"
    },
    {
      "id": "custom_e7475cea-919f-45d6-9137-89934cee59fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-5f9d-744c-99d3-d3a4b41d9dcc.webp",
      "image_media": {
        "alt_text": "Exterior of blue apartment building with beige mailboxes and a hedge.",
        "public_id": "019d270c-5f9d-744c-99d3-d3a4b41d9dcc",
        "storage_key": "property/6767906449166548/019d270c-5f9d-744c-99d3-d3a4b41d9dcc.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior view of a modern multifamily community showing blue siding, a row of mailboxes, and a landscaped entry.",
      "link": "",
      "alt_text": "Exterior of blue apartment building with beige mailboxes and a hedge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-b957-722b-913f-2a7bd3fc9a01.webp"
    },
    {
      "id": "custom_013f93f5-ad79-47e2-bea3-d45e2163a4b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-6048-765e-ac2e-3f47b039aec6.webp",
      "image_media": {
        "alt_text": "Outdoor community courtyard with a round picnic table, umbrella, grill, and string lights.",
        "public_id": "019d270c-6048-765e-ac2e-3f47b039aec6",
        "storage_key": "property/6767906449166548/019d270c-6048-765e-ac2e-3f47b039aec6.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Shared outdoor amenities area for residents with seating, a grill, and landscaped surroundings.",
      "link": "",
      "alt_text": "Outdoor community courtyard with a round picnic table, umbrella, grill, and string lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-b5dd-73ec-9384-4bd8ed67ca6a.webp"
    },
    {
      "id": "custom_c74c135d-8869-42d6-a68b-8fccf146b683",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-614f-7229-bfc1-3bf25bb9e4d1.webp",
      "image_media": {
        "alt_text": "Outdoor pool area with blue water, lime-green lounge chairs, and a fenced courtyard.",
        "public_id": "019d270c-614f-7229-bfc1-3bf25bb9e4d1",
        "storage_key": "property/6767906449166548/019d270c-614f-7229-bfc1-3bf25bb9e4d1.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Outdoor community pool at the property, surrounded by lime-green lounge chairs and a modern building, ideal for relaxing and socializing.",
      "link": "",
      "alt_text": "Outdoor pool area with blue water, lime-green lounge chairs, and a fenced courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-da4f-732e-9005-22796e0a13bb.webp"
    },
    {
      "id": "custom_a67e73ea-8472-48d1-a36f-9d95c62e4307",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-61bd-725c-8755-e8cb139b6599.webp",
      "image_media": {
        "alt_text": "Outdoor pool at a multifamily community with lime-green lounge chairs and apartment buildings in the background.",
        "public_id": "019d270c-61bd-725c-8755-e8cb139b6599",
        "storage_key": "property/6767906449166548/019d270c-61bd-725c-8755-e8cb139b6599.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Sunny outdoor pool area at a multifamily community, bordered by lime-green lounge chairs and modern apartment buildings.",
      "link": "",
      "alt_text": "Outdoor pool at a multifamily community with lime-green lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449166548/019cfb4f-0ebd-749e-8bbb-09b5106986c2.webp"
    },
    {
      "id": "custom_daf58aae-a42a-4f3b-80f3-e74e1739ee95",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-67ed-73fa-812b-e46f7197212e.webp",
      "image_media": {
        "alt_text": "Spacious lobby with a brick fireplace, modern chandelier, and tan leather seating.",
        "public_id": "019d270c-67ed-73fa-812b-e46f7197212e",
        "storage_key": "property/6767906449166548/019d270c-67ed-73fa-812b-e46f7197212e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Bright resident lounge featuring a brick fireplace, comfortable leather sofas, and a beverage area near glass doors.",
      "link": "",
      "alt_text": "Spacious lobby with a brick fireplace, modern chandelier, and tan leather seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-ca5b-70c5-b6da-384c12a20d6d.webp"
    },
    {
      "id": "custom_1f881f61-2762-43a4-b25d-bf29afd20702",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-693a-755c-b1f7-bc8d90d25f5d.webp",
      "image_media": {
        "alt_text": "Interior resident lounge with round table, desks, chairs, and large windows.",
        "public_id": "019d270c-693a-755c-b1f7-bc8d90d25f5d",
        "storage_key": "property/6767906449166548/019d270c-693a-755c-b1f7-bc8d90d25f5d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Modern community lounge with workstations, seating, and decor for residents.",
      "link": "",
      "alt_text": "Interior resident lounge with round table, desks, chairs, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-cc26-77c8-b480-f96fee673fbc.webp"
    },
    {
      "id": "custom_767b873b-f627-49cf-8bff-e3d61056fe65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-6d82-7446-b09e-83177c779cc0.webp",
      "image_media": {
        "alt_text": "Interior community lounge with leather sofas, a brick accent wall, a fireplace, and large windows.",
        "public_id": "019d270c-6d82-7446-b09e-83177c779cc0",
        "storage_key": "property/6767906449166548/019d270c-6d82-7446-b09e-83177c779cc0.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Spacious resident lounge with a fireplace, brick accent wall, and modern seating for gatherings.",
      "link": "",
      "alt_text": "Interior community lounge with leather sofas, a brick accent wall, a fireplace, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-cff4-776c-a2ca-c22948d7c76a.webp"
    },
    {
      "id": "custom_64f6aef1-686c-438f-aea7-4fd6b94cf112",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-6e24-728e-8cfd-813db353515c.webp",
      "image_media": {
        "alt_text": "Bright community gym with two treadmills and a stationary bike.",
        "public_id": "019d270c-6e24-728e-8cfd-813db353515c",
        "storage_key": "property/6767906449166548/019d270c-6e24-728e-8cfd-813db353515c.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Modern fitness center for residents, featuring cardio equipment (treadmills and a bike) and bright natural light from windows.",
      "link": "",
      "alt_text": "Bright community gym with two treadmills and a stationary bike.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449166548/019cfb4f-0449-72e8-96ce-8201b15b502a.webp"
    },
    {
      "id": "custom_6e6b6104-5c3f-4998-a309-69420a506cad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-7032-77fe-ad2a-a94b1dde70f0.webp",
      "image_media": {
        "alt_text": "On-site fitness center with treadmills, free weights, and a mirrored wall.",
        "public_id": "019d270c-7032-77fe-ad2a-a94b1dde70f0",
        "storage_key": "property/6767906449166548/019d270c-7032-77fe-ad2a-a94b1dde70f0.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Well-equipped apartment gym with cardio machines, free weights, medicine balls, and a mirror wall for residents.",
      "link": "",
      "alt_text": "On-site fitness center with treadmills, free weights, and a mirrored wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-e659-710d-a4e9-f0a99de0eaba.webp"
    },
    {
      "id": "custom_fb8755c4-3716-4112-af1e-02e5b99a4e3b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-720c-7343-a846-7161beb28bd8.webp",
      "image_media": {
        "alt_text": "Bright apartment living room with a fireplace, white sofa, and large windows.",
        "public_id": "019d270c-720c-7343-a846-7161beb28bd8",
        "storage_key": "property/6767906449166548/019d270c-720c-7343-a846-7161beb28bd8.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "A modern, well-lit apartment living room with a cozy fireplace, neutral decor, and seating for relaxing.",
      "link": "",
      "alt_text": "Bright apartment living room with a fireplace, white sofa, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449166548/019cfb4f-0faa-759b-8cef-56ea42df62d3.webp"
    },
    {
      "id": "custom_be0055b1-2542-40c5-9351-daea44a82a23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-78e6-7015-bebf-6b06b6a29fc6.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment living/dining area with a round dining table, two chairs, a sofa, lamp, and a glass door.",
        "public_id": "019d270c-78e6-7015-bebf-6b06b6a29fc6",
        "storage_key": "property/6767906449166548/019d270c-78e6-7015-bebf-6b06b6a29fc6.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy living/dining area in a modern apartment featuring a round dining table, two chairs, a sofa, and a glass door.",
      "link": "",
      "alt_text": "Interior view of an apartment living/dining area with a round dining table, two chairs, a sofa, lamp, and a glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-b833-734a-99e8-c252c365c789.webp"
    },
    {
      "id": "custom_769cf0aa-9e23-409b-9a51-79dae8872a9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-7928-73ea-a4cf-dfdf22de1cd4.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, sofa, coffee table, and large windows.",
        "public_id": "019d270c-7928-73ea-a4cf-dfdf22de1cd4",
        "storage_key": "property/6767906449166548/019d270c-7928-73ea-a4cf-dfdf22de1cd4.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious apartment living room with a cozy fireplace, neutral decor, and modern seating.",
      "link": "",
      "alt_text": "Living room with fireplace, sofa, coffee table, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-b5fa-719d-9c18-faa2bb096162.webp"
    },
    {
      "id": "custom_ea3a69b7-27d2-4276-b735-62d320873ca0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-7a23-776f-a212-9ae2b3bda37e.webp",
      "image_media": {
        "alt_text": "Interior apartment entry: front door, window with blinds, and a decorative console table.",
        "public_id": "019d270c-7a23-776f-a212-9ae2b3bda37e",
        "storage_key": "property/6767906449166548/019d270c-7a23-776f-a212-9ae2b3bda37e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment entry with a front door, natural light from the window, and a decorative console table with wall art.",
      "link": "",
      "alt_text": "Interior apartment entry: front door, window with blinds, and a decorative console table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-b5f8-76e8-ad7c-7fccad561dc3.webp"
    },
    {
      "id": "custom_555aab48-75b0-4268-99de-89afa60c9bf1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-81ce-7729-a75a-5cb9080dd08e.webp",
      "image_media": {
        "alt_text": "Bathroom with wood vanity, large mirror, toilet, and white tiled bathtub/shower.",
        "public_id": "019d270c-81ce-7729-a75a-5cb9080dd08e",
        "storage_key": "property/6767906449166548/019d270c-81ce-7729-a75a-5cb9080dd08e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with an oak vanity, mirror, toilet, and a white tub/shower combo.",
      "link": "",
      "alt_text": "Bathroom with wood vanity, large mirror, toilet, and white tiled bathtub/shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-b5ab-744f-ab09-2c82925f7940.webp"
    },
    {
      "id": "custom_e3e7ae01-a522-4e37-9ae0-0e58b6bf4f9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-82cb-73da-8519-4effe6de7473.webp",
      "image_media": {
        "alt_text": "Walk-in closet with white wire shelving, wicker baskets, and two gray pillows on the top shelf.",
        "public_id": "019d270c-82cb-73da-8519-4effe6de7473",
        "storage_key": "property/6767906449166548/019d270c-82cb-73da-8519-4effe6de7473.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Bright walk-in closet with white wire shelves, baskets, and neutral carpeting.",
      "link": "",
      "alt_text": "Walk-in closet with white wire shelving, wicker baskets, and two gray pillows on the top shelf.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-b621-75ef-a47b-048806a377c4.webp"
    },
    {
      "id": "custom_bfcdafbb-4b75-4b73-9c43-590cc965ba85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-82ae-762e-9478-fc6f273b1364.webp",
      "image_media": {
        "alt_text": "Living room in a furnished apartment with a gray sofa, geometric-pattern chair, and gold-accent coffee table.",
        "public_id": "019d270c-82ae-762e-9478-fc6f273b1364",
        "storage_key": "property/6767906449166548/019d270c-82ae-762e-9478-fc6f273b1364.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright, furnished living area with neutral tones and an open kitchen pass-through.",
      "link": "",
      "alt_text": "Living room in a furnished apartment with a gray sofa, geometric-pattern chair, and gold-accent coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-ca25-7614-9e41-027af3138902.webp"
    },
    {
      "id": "custom_acab701f-6ce7-4374-92c2-2932806b66ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-8367-71cc-a8de-e4ad60031cba.webp",
      "image_media": {
        "alt_text": "U-shaped kitchen with light wood cabinets, white appliances (stove, microwave, dishwasher), and a small rug.",
        "public_id": "019d270c-8367-71cc-a8de-e4ad60031cba",
        "storage_key": "property/6767906449166548/019d270c-8367-71cc-a8de-e4ad60031cba.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright kitchen with oak cabinets and white appliances, offering practical layout suitable for a modern apartment.",
      "link": "",
      "alt_text": "U-shaped kitchen with light wood cabinets, white appliances (stove, microwave, dishwasher), and a small rug.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-ca25-7614-9e41-067e9ad18187.webp"
    },
    {
      "id": "custom_9129e3fd-7b12-45dd-97fe-4464915ce5d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-8a4e-73b8-a02a-ef8876cc90c5.webp",
      "image_media": {
        "alt_text": "Bathroom in an apartment with a wooden vanity, large mirror, toilet, and bathtub with a striped shower curtain.",
        "public_id": "019d270c-8a4e-73b8-a02a-ef8876cc90c5",
        "storage_key": "property/6767906449166548/019d270c-8a4e-73b8-a02a-ef8876cc90c5.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom featuring a wooden vanity, toilet, and bathtub with a striped shower curtain; wall decor and shelved accents.",
      "link": "",
      "alt_text": "Bathroom in an apartment with a wooden vanity, large mirror, toilet, and bathtub with a striped shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-cc0a-71db-a069-a5e6b02bf3b4.webp"
    },
    {
      "id": "custom_761f1c21-ee6f-4e66-b161-bb1e440073fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-8a7e-74c1-975a-7f6a1247c3aa.webp",
      "image_media": {
        "alt_text": "Laundry room with two white front-loading washers/dryers, a striped towel, shelf, and pet items on the floor.",
        "public_id": "019d270c-8a7e-74c1-975a-7f6a1247c3aa",
        "storage_key": "property/6767906449166548/019d270c-8a7e-74c1-975a-7f6a1247c3aa.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "In-unit laundry nook with white front-load machines, a shelf, and pet-friendly touches.",
      "link": "",
      "alt_text": "Laundry room with two white front-loading washers/dryers, a striped towel, shelf, and pet items on the floor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-cc9f-770f-aeda-a0463cd9567b.webp"
    },
    {
      "id": "custom_e85b0687-b913-4144-b292-7008c705ce07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-8b34-7789-a463-7c22dd87f963.webp",
      "image_media": {
        "alt_text": "Laundry closet with detergent shelf, woven baskets, and wall art.",
        "public_id": "019d270c-8b34-7789-a463-7c22dd87f963",
        "storage_key": "property/6767906449166548/019d270c-8b34-7789-a463-7c22dd87f963.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "In-unit laundry closet with detergent shelf, storage baskets, and wall art.",
      "link": "",
      "alt_text": "Laundry closet with detergent shelf, woven baskets, and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-cd92-7172-b6ed-1449c834e9e4.webp"
    },
    {
      "id": "custom_e6b90c31-2681-4253-b2a0-bae9e169a215",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-8c92-75bf-9c78-afe75570b90a.webp",
      "image_media": {
        "alt_text": "Bright living room with fireplace, gray sofa, two patterned chairs, coffee table, and a wall-mounted TV above the mantel.",
        "public_id": "019d270c-8c92-75bf-9c78-afe75570b90a",
        "storage_key": "property/6767906449166548/019d270c-8c92-75bf-9c78-afe75570b90a.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment living area with a fireplace, modern seating, and nearby doorway to the bedroom.",
      "link": "",
      "alt_text": "Bright living room with fireplace, gray sofa, two patterned chairs, coffee table, and a wall-mounted TV above the mantel.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-cfe7-75f3-aa5f-d43c0dc376be.webp"
    },
    {
      "id": "custom_48429d43-70f6-4b09-93f0-cce86d0d4153",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-9468-735b-8e36-f1fbcd5bdaad.webp",
      "image_media": {
        "alt_text": "Bathroom with tub/shower, toilet, wooden vanity, large mirror, and towels.",
        "public_id": "019d270c-9468-735b-8e36-f1fbcd5bdaad",
        "storage_key": "property/6767906449166548/019d270c-9468-735b-8e36-f1fbcd5bdaad.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with tub/shower, toilet, and a wooden vanity under a large mirror.",
      "link": "",
      "alt_text": "Bathroom with tub/shower, toilet, wooden vanity, large mirror, and towels.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-daaf-7737-a83f-a5d7670f55e1.webp"
    },
    {
      "id": "custom_0fa87d7f-6f7e-4b4b-8998-23945952e90d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-9506-74be-a69b-8cf0ea986994.webp",
      "image_media": {
        "alt_text": "Dining nook with a wooden table, two chrome stools, and abstract art near a glass door.",
        "public_id": "019d270c-9506-74be-a69b-8cf0ea986994",
        "storage_key": "property/6767906449166548/019d270c-9506-74be-a69b-8cf0ea986994.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment dining area with a tall table, two stools, and modern artwork.",
      "link": "",
      "alt_text": "Dining nook with a wooden table, two chrome stools, and abstract art near a glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-dcbc-74de-b123-e52cb5eace85.webp"
    },
    {
      "id": "custom_9bfeeb81-893e-4b45-a3c0-71e808eaeb5f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-95c1-77f9-acfc-ea3bb9622877.webp",
      "image_media": {
        "alt_text": "Kitchen in an apartment with wooden cabinets, white refrigerator, microwave, and stove.",
        "public_id": "019d270c-95c1-77f9-acfc-ea3bb9622877",
        "storage_key": "property/6767906449166548/019d270c-95c1-77f9-acfc-ea3bb9622877.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment kitchen with oak cabinets, white appliances, and a clean, functional layout.",
      "link": "",
      "alt_text": "Kitchen in an apartment with wooden cabinets, white refrigerator, microwave, and stove.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-dd3e-72ef-b802-f9b48422b28e.webp"
    },
    {
      "id": "custom_47e34bda-ceaa-4a6e-8c97-96791612a3c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-9df9-753c-9fc7-9e5dd1d9a958.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment with a tufted bed, purple comforter, nightstand, and window with striped curtains.",
        "public_id": "019d270c-9df9-753c-9fc7-9e5dd1d9a958",
        "storage_key": "property/6767906449166548/019d270c-9df9-753c-9fc7-9e5dd1d9a958.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with a tufted headboard, purple bedding, and contemporary furnishings.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a tufted bed, purple comforter, nightstand, and window with striped curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-dda4-739d-9dbf-59bd7560acd7.webp"
    },
    {
      "id": "custom_a290a7d3-d76c-4a93-be04-cad4d839526a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-9ec4-73e9-b929-860ce4cc0af7.webp",
      "image_media": {
        "alt_text": "L-shaped apartment kitchen with light wood cabinets, white stove, microwave, and dishwasher.",
        "public_id": "019d270c-9ec4-73e9-b929-860ce4cc0af7",
        "storage_key": "property/6767906449166548/019d270c-9ec4-73e9-b929-860ce4cc0af7.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "L-shaped apartment kitchen with light wood cabinets, white appliances, and ample counter space.",
      "link": "",
      "alt_text": "L-shaped apartment kitchen with light wood cabinets, white stove, microwave, and dishwasher.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-e13b-7109-9f70-47bfdbb58f24.webp"
    },
    {
      "id": "custom_1b389cc9-045e-4726-972b-4068ba2e077a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-9f38-757f-a362-646c83f2aaf4.webp",
      "image_media": {
        "alt_text": "Bedroom with light wood bed frame, dresser, and two windows with curtains.",
        "public_id": "019d270c-9f38-757f-a362-646c83f2aaf4",
        "storage_key": "property/6767906449166548/019d270c-9f38-757f-a362-646c83f2aaf4.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom showing a light-finished bed frame, matching dresser, soft pink bedding, and daylight from two windows.",
      "link": "",
      "alt_text": "Bedroom with light wood bed frame, dresser, and two windows with curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-e18e-733b-ae8f-cfc8bd042da4.webp"
    },
    {
      "id": "custom_60c336f3-8abd-4ca9-80fd-e1d320442216",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-a23b-75f8-9339-472023cdd17d.webp",
      "image_media": {
        "alt_text": "Bedroom in a neutral apartment with a metal bed frame, two nightstands, lamps, and a window.",
        "public_id": "019d270c-a23b-75f8-9339-472023cdd17d",
        "storage_key": "property/6767906449166548/019d270c-a23b-75f8-9339-472023cdd17d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright bedroom in a modern apartment with white bedding, a metal bed frame, and soft natural light.",
      "link": "",
      "alt_text": "Bedroom in a neutral apartment with a metal bed frame, two nightstands, lamps, and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-e150-71df-97bc-6e9afdae4f3d.webp"
    },
    {
      "id": "custom_691a9966-c492-414c-a081-18ef49476c9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-a69d-74b8-a75c-345fe2c43d8c.webp",
      "image_media": {
        "alt_text": "Open-concept living room with white sofa, coffee table, and a partial view of the kitchen.",
        "public_id": "019d270c-a69d-74b8-a75c-345fe2c43d8c",
        "storage_key": "property/6767906449166548/019d270c-a69d-74b8-a75c-345fe2c43d8c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Open-concept living area in an apartment featuring a pass-through kitchen, seating, and a TV.",
      "link": "",
      "alt_text": "Open-concept living room with white sofa, coffee table, and a partial view of the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-e6ad-7236-8a35-1f0dcdfcfd02.webp"
    },
    {
      "id": "custom_abb30fb3-1218-4736-94b6-521a0c3c6952",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-a712-75e4-917b-329e19cddf1d.webp",
      "image_media": {
        "alt_text": "Balcony seating with wicker chairs and a round table; cups, lemons, and a vase of sunflowers on the railing.",
        "public_id": "019d270c-a712-75e4-917b-329e19cddf1d",
        "storage_key": "property/6767906449166548/019d270c-a712-75e4-917b-329e19cddf1d.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Lifestyle",
      "description": "Outdoor balcony scene at a multifamily property with wicker seating, a round table, coffee cups, lemons, and a vase of sunflowers.",
      "link": "",
      "alt_text": "Balcony seating with wicker chairs and a round table; cups, lemons, and a vase of sunflowers on the railing.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449166548/019cfb4f-1118-728f-abea-22e57a8c9f8a.webp"
    },
    {
      "id": "custom_a022cb81-0791-44d5-86c0-54c4f495e599",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-a859-739c-a415-ce49914bc4ad.webp",
      "image_media": {
        "alt_text": "Silhouette of a city skyline at sunset with an orange sky.",
        "public_id": "019d270c-a859-739c-a415-ce49914bc4ad",
        "storage_key": "property/6767906449166548/019d270c-a859-739c-a415-ce49914bc4ad.webp",
        "width": 1024,
        "height": 681
      },
      "title": "Lifestyle",
      "description": "A dramatic silhouette of a city skyline against a warm orange sunset sky.",
      "link": "",
      "alt_text": "Silhouette of a city skyline at sunset with an orange sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449166548/019cfb4f-1001-7459-af16-13e63b437455.webp"
    },
    {
      "id": "custom_a7276cff-4b98-4df1-9cf0-d66cf77877a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-abd7-757b-b46a-0e407e2e60c5.webp",
      "image_media": {
        "alt_text": "Aerial daytime cityscape with a church in the foreground and grid of streets.",
        "public_id": "019d270c-abd7-757b-b46a-0e407e2e60c5",
        "storage_key": "property/6767906449166548/019d270c-abd7-757b-b46a-0e407e2e60c5.webp",
        "width": 1024,
        "height": 576
      },
      "title": "Lifestyle",
      "description": "Aerial city view featuring a prominent church at the front and surrounding buildings and roads.",
      "link": "",
      "alt_text": "Aerial daytime cityscape with a church in the foreground and grid of streets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449166548/019cfb4f-1117-72fa-bc2f-808a0e93c49f.webp"
    },
    {
      "id": "custom_5d22291e-8dc8-4535-b680-ee5eae92b348",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d270c-acfc-7447-ad12-f13259dcc746.webp",
      "image_media": {
        "alt_text": "Evening view of a golden statue atop a rocky pedestal beside a tranquil pond and landscaped greenery.",
        "public_id": "019d270c-acfc-7447-ad12-f13259dcc746",
        "storage_key": "property/6767906449166548/019d270c-acfc-7447-ad12-f13259dcc746.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Lifestyle",
      "description": "Exterior courtyard with a glowing statue and rock formations by a water feature, highlighting the property's landscaped grounds.",
      "link": "",
      "alt_text": "Evening view of a golden statue atop a rocky pedestal beside a tranquil pond and landscaped greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449166548/019cfb4f-1118-728f-abea-19e8b212078c.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_af330f64-6465-4e4e-84e4-cddb6a293270",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2526 N Greenwich Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and fried pickles, and the rolls are a highlight. They highlight the fair prices and fun, casual atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.texasroadhouse.com/locations/kansas/wichita-n-greenwich-rd?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=1637772610376225648&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "37.7278459",
      "poi_longitude": "-97.2071071",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-634-1106",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464d-75b2-9fec-7e3a1617e0cb",
        "storage_key": "property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_-1abr9uocRcNNWCIOJuhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_30f57e08-8b25-4979-ae40-47cc477f69e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Topgolf Wichita",
      "poi_type": "Restaurants",
      "poi_address": "2976 N Greenwich Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers fun games and a variety of food and drinks. They also highlight the upbeat atmosphere and friendly staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-6b8b-7179-a642-9f2a3bd3c1af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6b8b-7179-a642-9f2a3bd3c1af",
        "storage_key": "property/6767906449166548/019cfb4f-6b8b-7179-a642-9f2a3bd3c1af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://topgolf.com/us/wichita/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3659202844621293977&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-wichita",
      "poi_latitude": "37.7368549",
      "poi_longitude": "-97.2071488",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-394-4065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464d-75b2-9fec-7e3a1617e0cb",
        "storage_key": "property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGUU5Coj9uocRmUnAkpkZyDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_912242f0-f9d4-4057-927e-20e23d261984",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Wichita",
      "poi_type": "Restaurants",
      "poi_address": "1240 N Greenwich Rd, Wichita, KS 67206, USA",
      "poi_short_description": "Family-friendly, game joint known for rotisserie chicken, pickleball courts and yard games.",
      "poi_long_description": "People say this restaurant offers a variety of fun outdoor games, pickleball courts, and a spacious indoor area with TVs and a bar. They also highlight the fun and energetic atmosphere, and the friendly staff.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://chickennpickle.com/location/wichita/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3640495953640467354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chicken-n-pickle---wichita",
      "poi_latitude": "37.70694599999999",
      "poi_longitude": "-97.205714",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-535-7150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464d-75b2-9fec-7e3a1617e0cb",
        "storage_key": "property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1ZsOYJL9uocRmqv8GsijhTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_545fa71d-5648-4a5e-85e2-0ab7f267e6e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2400 N Greenwich Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves good chicken sandwiches and waffle fries. They also highlight the quick service and friendly staff.\n\nOther reviews mention the drive-thru can be confusing.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.chick-fil-a.com/locations/ks/k96-greenwich-rd-ks?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4809767043547304648&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "37.726752",
      "poi_longitude": "-97.207335",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-369-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464d-75b2-9fec-7e3a1617e0cb",
        "storage_key": "property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJre8SHCP9uocRyJIEk6S5v0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_e09f9fb4-acee-4e81-aed0-e8358fd7f5ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Towne East Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "7700 E Kellogg Dr, Wichita, KS 67207, USA",
      "poi_short_description": "Big mall with a classic range of department stores, specialty boutiques & kiosks, plus a food court.",
      "poi_long_description": "People say this shopping center offers a wide selection of clothes, shoes, and sporting goods, and has a good food court. They also highlight the clean and safe environment, and the fun atmosphere.\n\nOther reviews mention the games can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-2e6b-73b8-a741-a41d04c58776.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-2e6b-73b8-a741-a41d04c58776",
        "storage_key": "property/6767906449166548/019cfb4f-2e6b-73b8-a741-a41d04c58776.webp",
        "width": 550,
        "height": 366
      },
      "poi_business_url": "https://www.simon.com/mall/towne-east-square",
      "poi_directions_map_url": "https://maps.google.com/?cid=15194517817475507784&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "towne-east-square",
      "poi_latitude": "37.6832262",
      "poi_longitude": "-97.2469947",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-686-3341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464e-7424-ba06-0830dda56889",
        "storage_key": "property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZfKSnrz8uocRSKb4c3PF3dI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_63681639-fb3f-4037-850d-11802f3d99cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1423 N Webb Rd Ste 101, Wichita, KS 67206, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh, organic produce, meat, and prepackaged goods, as well as a bakery, prepared foods, and a coffee shop. They also highlight the clean, organized layout, the friendly and helpful staff, and the convenient Amazon returns.\n\nOther reviews mention the store can be understocked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-304e-778f-a727-7a3de39d42b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-304e-778f-a727-7a3de39d42b4",
        "storage_key": "property/6767906449166548/019cfb4f-304e-778f-a727-7a3de39d42b4.webp",
        "width": 1280,
        "height": 934
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/wichita?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=11170048129198724117&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "37.7089215",
      "poi_longitude": "-97.227764",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-630-8484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4655-772b-bc33-b844717a6b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4655-772b-bc33-b844717a6b02",
        "storage_key": "property/6767906449166548/019cfb4f-4655-772b-bc33-b844717a6b02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaVf9R_n8uocRFRTokJf7A5s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5b1d0867-9b16-42e7-9a45-7354b8c90adb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1800 N Rock Rd Ste 120, Wichita, KS 67206, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, unique snacks, and beautiful flowers. They highlight the affordable prices and the clean, well-stocked store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-2e51-7247-a84a-c7aa3c285f83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-2e51-7247-a84a-c7aa3c285f83",
        "storage_key": "property/6767906449166548/019cfb4f-2e51-7247-a84a-c7aa3c285f83.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://locations.traderjoes.com/ks/wichita/729/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15564502814785791359&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "37.7163031",
      "poi_longitude": "-97.2434865",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-634-1846",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4655-772b-bc33-b844717a6b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4655-772b-bc33-b844717a6b02",
        "storage_key": "property/6767906449166548/019cfb4f-4655-772b-bc33-b844717a6b02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaX4mJJL9uocRf-XfhNg4ANg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_316e34aa-223d-43ea-bfd6-7dfa71299536",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "3350 N Woodlawn St, Wichita, KS 67220, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of home items, including paint, and has helpful and friendly staff. They also highlight the competitive prices and good sales.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-304b-72c8-80d7-60eece06f7db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-304b-72c8-80d7-60eece06f7db",
        "storage_key": "property/6767906449166548/019cfb4f-304b-72c8-80d7-60eece06f7db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/East-Wichita/KS/Wichita/67220/2204?emt=MSEN?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10636944138880415122&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "37.7443293",
      "poi_longitude": "-97.2612274",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-681-0899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464e-7424-ba06-0830dda56889",
        "storage_key": "property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf_RUnE39uocRkvWjXVYEnpM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_b07bef0d-383b-48c0-bde9-4b8dac6e40f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "3250 N Toben St, Wichita, KS 67226, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "People say this home improvement store offers a wide variety of products at reasonable prices, including construction supplies, and is a great place for DIY projects. They also highlight the helpful staff and convenient pick-up option.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-30a4-736e-9f15-67fb79527507.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-30a4-736e-9f15-67fb79527507",
        "storage_key": "property/6767906449166548/019cfb4f-30a4-736e-9f15-67fb79527507.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3275&utm_source=localcard&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6112294342705808708&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "menards",
      "poi_latitude": "37.743853",
      "poi_longitude": "-97.230225",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-630-8307",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464e-7424-ba06-0830dda56889",
        "storage_key": "property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJB4oMUXD9uocRRAWcA1I701Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_40aab706-6905-4262-bc57-66cd781d488d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Wichita State University",
      "poi_type": "Education",
      "poi_address": "1845 Fairmount St, Wichita, KS 67260, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.wichita.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2193094869087118587&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-state-university",
      "poi_latitude": "37.7190782",
      "poi_longitude": "-97.291526",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-978-3456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4648-7558-9478-b8c8daf2fa76",
        "storage_key": "property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSYDXm-niuocR-2Sr9ilwbx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1da13e25-3a32-41fb-81af-3d0e0b6b8d99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "WSU Tech | National Center for Aviation Training (NCAT)",
      "poi_type": "Education",
      "poi_address": "4004 N Webb Rd, Wichita, KS 67226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-6ba6-74bb-9c9d-0d8d2fa01f0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6ba6-74bb-9c9d-0d8d2fa01f0c",
        "storage_key": "property/6767906449166548/019cfb4f-6ba6-74bb-9c9d-0d8d2fa01f0c.webp",
        "width": 639,
        "height": 359
      },
      "poi_business_url": "https://wsutech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12806940655175411833&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wsu-tech--national-center-for-aviation-training-ncat",
      "poi_latitude": "37.756972",
      "poi_longitude": "-97.2242927",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-677-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4648-7558-9478-b8c8daf2fa76",
        "storage_key": "property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJA-DVNYACu4cReSg9-6tku7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_374f4301-28bf-41ad-a4c0-3684de34cf84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Woolsey Hall",
      "poi_type": "Education",
      "poi_address": "Student Wellness Center Steve Clark YMCA 2060 N Mid-Campus Drive, Wichita, KS 67208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-6b3a-753c-b05c-8ee25abeaeee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6b3a-753c-b05c-8ee25abeaeee",
        "storage_key": "property/6767906449166548/019cfb4f-6b3a-753c-b05c-8ee25abeaeee.webp",
        "width": 1280,
        "height": 906
      },
      "poi_business_url": "https://www.wichita.edu/academics/business/woolsey_hall_2022.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=8990881046444541568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woolsey-hall",
      "poi_latitude": "37.7186727",
      "poi_longitude": "-97.2882013",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-978-4792",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4648-7558-9478-b8c8daf2fa76",
        "storage_key": "property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-e46vvTjuocRgIYeD60Gxnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_007f8085-e07a-4ed3-8786-c1ac3a7579db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Charles Koch Arena",
      "poi_type": "Entertainment",
      "poi_address": "1845 Fairmount St, Wichita, KS 67260, USA",
      "poi_short_description": "Huge sporting venue inside Koch Arena hosting basketball games, as well as graduations.",
      "poi_long_description": "People say this arena is a great venue for graduations, sporting events, and concerts. They highlight the easy access, organized entry, and helpful staff. They also like the spacious seating, good views, and large TVs that allow for close-up views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-6b7a-722d-8fe3-cc127adbf71c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6b7a-722d-8fe3-cc127adbf71c",
        "storage_key": "property/6767906449166548/019cfb4f-6b7a-722d-8fe3-cc127adbf71c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.goshockers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14669727161295634234&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "charles-koch-arena",
      "poi_latitude": "37.7218564",
      "poi_longitude": "-97.2973448",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-978-3267",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4654-7094-8cf0-e11f019e4544",
        "storage_key": "property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Q884-_iuocROv_sMCFXlcs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_c1f07970-1f91-4b29-87ea-7ccb1359096e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Museum of World Treasures",
      "poi_type": "Entertainment",
      "poi_address": "835 E 1st St N, Wichita, KS 67202, USA",
      "poi_short_description": "A history-of-the-world museum with an educational focus & hands-on children's activity center.",
      "poi_long_description": "People say this museum offers a diverse collection of artifacts from around the world and across many different time periods, including dinosaurs, mummies, and items from the Western era. They highlight the museum is packed with excellent exhibits and provides a good experience for families. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-351e-74c7-8775-db0e129f5998.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-351e-74c7-8775-db0e129f5998",
        "storage_key": "property/6767906449166548/019cfb4f-351e-74c7-8775-db0e129f5998.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "http://worldtreasures.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1404316722265454010&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "museum-of-world-treasures",
      "poi_latitude": "37.687089",
      "poi_longitude": "-97.327885",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4642-70fb-871a-ed79d2d78011.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4642-70fb-871a-ed79d2d78011",
        "storage_key": "property/6767906449166548/019cfb4f-4642-70fb-871a-ed79d2d78011.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJdz_xfJXjuocRuvXFVp4ifRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_8944a8e0-a55b-4c0c-9d9a-0c90c989be9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Cessna Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1845 E 21st St N, Wichita, KS 67260, USA",
      "poi_short_description": "Stadium used for track meets and other sports events with bleachers.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://goshockers.com/sports/2015/5/26/Cessna_Stadium.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1895230992599072842&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cessna-stadium",
      "poi_latitude": "37.7217064",
      "poi_longitude": "-97.2955332",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-978-5556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4652-7368-8912-25b7efbbce16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4652-7368-8912-25b7efbbce16",
        "storage_key": "property/6767906449166548/019cfb4f-4652-7368-8912-25b7efbbce16.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHwFEhe_iuocRSsAt4Ys2TRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_dffec80d-6d1a-4547-8a86-28e83b956f03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Frank Lloyd Wright's Allen House",
      "poi_type": "Entertainment",
      "poi_address": "255 N Roosevelt St, Wichita, KS 67208, USA",
      "poi_short_description": "Guided tours through the period interiors of a 1918 Prairie-style home by Frank Lloyd Wright.",
      "poi_long_description": "People say this museum offers an amazing presentation of architecture and a fascinating guided tour. They highlight the historical significance of the house and the knowledgeable docents. They also like the friendly and entertaining tour guides. ",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://flwrightwichita.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14152560708377734465&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "frank-lloyd-wrights-allen-house",
      "poi_latitude": "37.6897888",
      "poi_longitude": "-97.2924084",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 316-687-1027",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4642-70fb-871a-ed79d2d78011.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4642-70fb-871a-ed79d2d78011",
        "storage_key": "property/6767906449166548/019cfb4f-4642-70fb-871a-ed79d2d78011.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJmx3qVRPjuocRQW0BFfv-Z8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f101acbd-f7a8-46f5-97fd-b5bb33dbeab2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Eck Stadium - Tyler Field",
      "poi_type": "Entertainment",
      "poi_address": "4100 E 21st St N, Wichita, KS 67208, USA",
      "poi_short_description": "Cozy venue with outfield benches and other seating for college baseball games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-6d1e-776d-b967-dc4983c7e16d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6d1e-776d-b967-dc4983c7e16d",
        "storage_key": "property/6767906449166548/019cfb4f-6d1e-776d-b967-dc4983c7e16d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://goshockers.com/sports/2015/5/26/Eck_Stadium.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16739415824998152798&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eck-stadium---tyler-field",
      "poi_latitude": "37.721554",
      "poi_longitude": "-97.2889522",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-978-3636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4652-7368-8912-25b7efbbce16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4652-7368-8912-25b7efbbce16",
        "storage_key": "property/6767906449166548/019cfb4f-4652-7368-8912-25b7efbbce16.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFcCoDOjiuocRXjqR7ABaTug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_b5f952bb-a428-47d5-b962-5f1d76803609",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Robert D. Love Downtown YMCA - Greater Wichita YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "402 N Market St, Wichita, KS 67202, USA",
      "poi_short_description": "Nonprofit community center with an indoor track, pools, and courts for racquetball and basketball.",
      "poi_long_description": "People say this gym offers a variety of equipment, a pool, and a track. They also highlight the spacious layout, the separate saunas, and the friendly staff.\n\nOther reviews mention the parking can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-6cfb-7484-ae83-2b21b11147ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6cfb-7484-ae83-2b21b11147ab",
        "storage_key": "property/6767906449166548/019cfb4f-6cfb-7484-ae83-2b21b11147ab.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ymcawichita.org/locations/robert-d-love-downtown-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=2962762509539940888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "robert-d-love-downtown-ymca---greater-wichita-ymca",
      "poi_latitude": "37.6924977",
      "poi_longitude": "-97.33655720000002",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-264-9374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4654-7094-8cf0-e11f019e4544",
        "storage_key": "property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNfK39MPjuocRGBr5Fs7YHSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6f271b9d-d7bf-46fb-93cb-9b4e09094b71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Prime Time Barber Shop North Wichita",
      "poi_type": "Health and Wellness",
      "poi_address": "727 W 13th St N, Wichita, KS 67203, USA",
      "poi_short_description": "Barbershop featuring a friendly staff of skilled pros, plus kids' cuts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-3592-75ca-8875-9e5abfc57055.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-3592-75ca-8875-9e5abfc57055",
        "storage_key": "property/6767906449166548/019cfb4f-3592-75ca-8875-9e5abfc57055.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://getsquire.com/booking/book/prime-time-barbershop-north-wichita",
      "poi_directions_map_url": "https://maps.google.com/?cid=13837457956166592306&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "prime-time-barber-shop-north-wichita",
      "poi_latitude": "37.7076339",
      "poi_longitude": "-97.3476791",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-219-3132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4654-7094-8cf0-e11f019e4544",
        "storage_key": "property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZcaWNiviuocRMme2d7KGCMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_96738c54-cf00-425e-8f9d-4042f746e73a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3535 N Rock Rd Ste 200, Wichita, KS 67226, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of well-maintained equipment and is rarely crowded. They also highlight the affordable membership options, the friendly and helpful staff, and the clean facilities.\n\nOther reviews mention the air conditioning can be inadequate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-6d4f-7269-9b47-61a335ef60cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6d4f-7269-9b47-61a335ef60cc",
        "storage_key": "property/6767906449166548/019cfb4f-6d4f-7269-9b47-61a335ef60cc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/wichita-n-rock-rd-ks?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=4859550944777095639&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "37.7472922",
      "poi_longitude": "-97.2476434",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-831-7380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4654-7094-8cf0-e11f019e4544",
        "storage_key": "property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsWiF9Fz9uocR10laV9aXcEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_72aba23a-a6d0-4034-bc95-261433fdf2be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - Rock Road",
      "poi_type": "Health and Wellness",
      "poi_address": "1551 N Rock Rd, Wichita, KS 67206, USA",
      "poi_short_description": "State-of-the-art fitness center chain outlet in Wichita, Kansas, offering a variety of workout options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-38ff-755a-914f-5066468f4e05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-38ff-755a-914f-5066468f4e05",
        "storage_key": "property/6767906449166548/019cfb4f-38ff-755a-914f-5066468f4e05.webp",
        "width": 862,
        "height": 485
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/rock-road.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=14856835678487964422&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---rock-road",
      "poi_latitude": "37.7117118",
      "poi_longitude": "-97.245851",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-634-0094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4654-7094-8cf0-e11f019e4544",
        "storage_key": "property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMdkopd_8uocRBuufrlUVLs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3519958c-3875-4339-87ca-9df5258359af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - East Central",
      "poi_type": "Health and Wellness",
      "poi_address": "6100 E Central Ave, Wichita, KS 67208, USA",
      "poi_short_description": "Gym, yoga spot, and fitness center featuring cardio equipment, weight machines and free weights, plus 1-on-1 training.",
      "poi_long_description": "People say this gym offers a wide variety of new and updated equipment, as well as recovery amenities like hydro chairs, a sauna, and a jacuzzi. They also highlight the friendly, helpful, and supportive staff, and the unique, retro vibe with neon lighting.\n\nOther reviews mention the gym can be hot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-6d40-747c-aa6f-da854b7e29cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6d40-747c-aa6f-da854b7e29cd",
        "storage_key": "property/6767906449166548/019cfb4f-6d40-747c-aa6f-da854b7e29cd.webp",
        "width": 1280,
        "height": 837
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/east-central.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=16504592488182224350&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---east-central",
      "poi_latitude": "37.6952972",
      "poi_longitude": "-97.2664031",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-681-3010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4654-7094-8cf0-e11f019e4544",
        "storage_key": "property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm4G50TTjuocR3pWuRGwXDOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4cafce7c-ac74-4ab0-8321-71cbeeb6fdca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Wichita Barber Company",
      "poi_type": "Health and Wellness",
      "poi_address": "1640 E 2nd St N, Wichita, KS 67214, USA",
      "poi_short_description": "Barber shop offering haircuts, shaves, and VIP treatments in an environment with a vibe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-39a0-76d8-91b5-63eb3e1f1ee5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-39a0-76d8-91b5-63eb3e1f1ee5",
        "storage_key": "property/6767906449166548/019cfb4f-39a0-76d8-91b5-63eb3e1f1ee5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://wichitabarbercompany.booksy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12079813653761229796&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-barber-company",
      "poi_latitude": "37.6899721",
      "poi_longitude": "-97.3177637",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-304-3868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4654-7094-8cf0-e11f019e4544",
        "storage_key": "property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_sikvnjuocR5ANaOYQepKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_239bef1e-293f-4544-854d-8fe8e9d0d84a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Prime Time Barber Shop East Wichita",
      "poi_type": "Health and Wellness",
      "poi_address": "505 S Woodlawn St, Wichita, KS 67207, USA",
      "poi_short_description": "Barbershop offering haircuts with appointments recommended.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-6ee3-725d-ad20-14e6d78be526.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6ee3-725d-ad20-14e6d78be526",
        "storage_key": "property/6767906449166548/019cfb4f-6ee3-725d-ad20-14e6d78be526.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://getsquire.com/booking/book/prime-time-barbershop-east-wichita",
      "poi_directions_map_url": "https://maps.google.com/?cid=12886161975853718998&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "prime-time-barber-shop-east-wichita",
      "poi_latitude": "37.6789511",
      "poi_longitude": "-97.2626463",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 316-400-5697",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4654-7094-8cf0-e11f019e4544",
        "storage_key": "property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt9AOcbL9uocR1h3oEAvY1LI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_449bd737-8e26-4937-bd19-2cb62fa6133b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Classy Nails and Spa Wichita",
      "poi_type": "Health and Wellness",
      "poi_address": "2413 N Greenwich Rd Ste 111, Wichita, KS 67226, USA",
      "poi_short_description": "Clean nail salon offering gel manicures and pedis as well as eyelash extensions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-6f8f-746e-865d-394082150a2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6f8f-746e-865d-394082150a2c",
        "storage_key": "property/6767906449166548/019cfb4f-6f8f-746e-865d-394082150a2c.webp",
        "width": 1096,
        "height": 841
      },
      "poi_business_url": "http://classynailsspawichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5720972690523935251&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "classy-nails-and-spa-wichita",
      "poi_latitude": "37.7267288",
      "poi_longitude": "-97.2087584",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-977-8864",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4654-7094-8cf0-e11f019e4544",
        "storage_key": "property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzwYliLD9uocRE9Jj3Fn6ZE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_2ff2de60-58f0-4a0e-ab29-e346919e148e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "UrgentPet Care",
      "poi_type": "Health and Wellness",
      "poi_address": "11110 E 26th St N Suite 600, Wichita, KS 67226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-6f64-70ac-ba41-a8c4e9667326.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6f64-70ac-ba41-a8c4e9667326",
        "storage_key": "property/6767906449166548/019cfb4f-6f64-70ac-ba41-a8c4e9667326.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://urgentpetvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10243324419205437497&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urgentpet-care",
      "poi_latitude": "37.7331206",
      "poi_longitude": "-97.2090998",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-440-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4654-7094-8cf0-e11f019e4544",
        "storage_key": "property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoSvzoXb9uocRORjTrUmZJ44",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_d3504e18-6f73-4f65-b383-ee258f283648",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Wesley Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "550 N Hillside St Main Entrance, Wichita, KS 67214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-3b5b-7468-8a93-4133a85ab60f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-3b5b-7468-8a93-4133a85ab60f",
        "storage_key": "property/6767906449166548/019cfb4f-3b5b-7468-8a93-4133a85ab60f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wesleymc.com/locations/wesley-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17159963175428114376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wesley-medical-center",
      "poi_latitude": "37.6964068",
      "poi_longitude": "-97.2983475",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-962-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4645-7589-8ebc-0a98e9767749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4645-7589-8ebc-0a98e9767749",
        "storage_key": "property/6767906449166548/019cfb4f-4645-7589-8ebc-0a98e9767749.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJAxK-0xHjuocRyEctNpdvJO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_beae736a-4cb5-41b9-925e-622e010876fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Ascension Via Christi St. Francis",
      "poi_type": "Health and Wellness",
      "poi_address": "929 St Francis, Wichita, KS 67214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-6fd5-766a-86b3-cf233e37ebcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-6fd5-766a-86b3-cf233e37ebcc",
        "storage_key": "property/6767906449166548/019cfb4f-6fd5-766a-86b3-cf233e37ebcc.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/kansas/kswic/wichita-ascension-via-christi-st-francis?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16408748786587986507&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-via-christi-st-francis",
      "poi_latitude": "37.6994424",
      "poi_longitude": "-97.3324685",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-268-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4645-7589-8ebc-0a98e9767749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4645-7589-8ebc-0a98e9767749",
        "storage_key": "property/6767906449166548/019cfb4f-4645-7589-8ebc-0a98e9767749.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJEQufU8jjuocRS-oyiRWWt-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_eedc7783-72b9-4e26-bcbd-0bdfee1a3115",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Great Plains Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6232 East 29th St N #2200, Wichita, KS 67220, USA",
      "poi_short_description": "Indoor-outdoor facilities designed to educate about the flora & fauna of the Great Plains.",
      "poi_long_description": "People say this nature preserve offers beautiful walking trails, diverse wildlife viewing, and opportunities to connect with nature. They highlight the peaceful and relaxing atmosphere, and the well-maintained trails with informative signage. They also like the friendly people and the availability of benches for observation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-3b93-756d-b7c6-76ac3bfa7a40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-3b93-756d-b7c6-76ac3bfa7a40",
        "storage_key": "property/6767906449166548/019cfb4f-3b93-756d-b7c6-76ac3bfa7a40.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://gpnc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16028016397833359637&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-plains-nature-center",
      "poi_latitude": "37.73924",
      "poi_longitude": "-97.263722",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-683-5499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4642-70fb-871a-f370702c2845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4642-70fb-871a-f370702c2845",
        "storage_key": "property/6767906449166548/019cfb4f-4642-70fb-871a-f370702c2845.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvcw5n0z9uocRFVH-Zv7zbt4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_d6b48392-02b2-49b8-996e-d38b65f3026e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Fairmount Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1647 N Yale Blvd, Wichita, KS 67218, USA",
      "poi_short_description": "Spacious park featuring a playground, a splash fountain and a community center.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-71e0-746c-8d4a-0d215b9342aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-71e0-746c-8d4a-0d215b9342aa",
        "storage_key": "property/6767906449166548/019cfb4f-71e0-746c-8d4a-0d215b9342aa.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Fairmount-Park-37",
      "poi_directions_map_url": "https://maps.google.com/?cid=11580955339775493795&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fairmount-park",
      "poi_latitude": "37.7127054",
      "poi_longitude": "-97.29159",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-268-4361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4642-70fb-871a-f370702c2845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4642-70fb-871a-f370702c2845",
        "storage_key": "property/6767906449166548/019cfb4f-4642-70fb-871a-f370702c2845.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3aE5LuLiuocRo0b74oXRt6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_e007ea4a-3cee-41c1-a681-3df0bbbe8c5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Edgemoor Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5815 E 9th St N, Wichita, KS 67208, USA",
      "poi_short_description": "Park featuring a splash pad and skate park along with basketball and tennis courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-3cfe-72d0-b3ae-af4e4486f03f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-3cfe-72d0-b3ae-af4e4486f03f",
        "storage_key": "property/6767906449166548/019cfb4f-3cfe-72d0-b3ae-af4e4486f03f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Edgemoor-Park-20",
      "poi_directions_map_url": "https://maps.google.com/?cid=14777509089755302817&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edgemoor-park",
      "poi_latitude": "37.70038470000001",
      "poi_longitude": "-97.2688025",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-268-4361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4642-70fb-871a-f370702c2845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4642-70fb-871a-f370702c2845",
        "storage_key": "property/6767906449166548/019cfb4f-4642-70fb-871a-f370702c2845.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxST4RjLjuocRoYv49zhCFM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_8cc0501c-2200-448a-a38a-fae48a8ebb59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "MacDonald Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "840 N Yale Ave, Wichita, KS 67208, USA",
      "poi_short_description": "Public city 18-hole golf course dotted with ponds & mature trees & offering golf carts.",
      "poi_long_description": "Public city 18-hole golf course dotted with ponds & mature trees & offering golf carts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-3efe-704f-83ed-7fb75b87f96d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-3efe-704f-83ed-7fb75b87f96d",
        "storage_key": "property/6767906449166548/019cfb4f-3efe-704f-83ed-7fb75b87f96d.webp",
        "width": 1280,
        "height": 279
      },
      "poi_business_url": "https://www.wichita.gov/facilities/facility/details/MacDonald-Golf-Course-149",
      "poi_directions_map_url": "https://maps.google.com/?cid=12364549608739728143&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "macdonald-golf-course",
      "poi_latitude": "37.6986098",
      "poi_longitude": "-97.2919043",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-688-9391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-467e-7569-a2cb-aac66f35ea64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-467e-7569-a2cb-aac66f35ea64",
        "storage_key": "property/6767906449166548/019cfb4f-467e-7569-a2cb-aac66f35ea64.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJATNFVBjjuocRD2ug5Fu0l6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_f773bb7b-256a-4932-b63a-45106f7d64b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Eastborough Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "34 Willowbrook Rd, Eastborough, KS 67207, USA",
      "poi_short_description": "Kid-friendly park featuring playgrounds and picnic tables by a pond with a small waterfall.",
      "poi_long_description": "People say this city park offers a playground, walking paths, a pond, and picnic tables. They highlight the park's clean, relaxing, and family-friendly atmosphere, as well as the beautiful scenery with ducks, geese, trees, and flowers. They also like the meandering concrete paths with bridges.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.eastborough-ks.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16492685975084465095&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eastborough-park",
      "poi_latitude": "37.6799973",
      "poi_longitude": "-97.2605371",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-682-4111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4642-70fb-871a-f370702c2845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4642-70fb-871a-f370702c2845",
        "storage_key": "property/6767906449166548/019cfb4f-4642-70fb-871a-f370702c2845.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5chJ8K38uocRx_v5KIPK4eQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_d1e406fc-a404-4736-8128-bd9b767582e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Colonel James Jabara Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3512 N Webb Rd, Wichita, KS 67226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-40c3-72a4-a1d9-8f4a0cbe1c08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-40c3-72a4-a1d9-8f4a0cbe1c08",
        "storage_key": "property/6767906449166548/019cfb4f-40c3-72a4-a1d9-8f4a0cbe1c08.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flywichita.com/general-aviation-jabara/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4247184628307720702&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "colonel-james-jabara-airport",
      "poi_latitude": "37.747501",
      "poi_longitude": "-97.221107",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-636-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-49af-773f-b53a-6333eab4f1bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-49af-773f-b53a-6333eab4f1bd",
        "storage_key": "property/6767906449166548/019cfb4f-49af-773f-b53a-6333eab4f1bd.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2QXGMHj9uocR_vnHueoH8To",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_4d0ba46c-1a05-4109-a842-670c7125886f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Beech Factory Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "9709 E Central Ave, Wichita, KS 67206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-40ca-77fa-a909-5ef23f6478f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-40ca-77fa-a909-5ef23f6478f6",
        "storage_key": "property/6767906449166548/019cfb4f-40ca-77fa-a909-5ef23f6478f6.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.beechcraft.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2405539519632020958&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beech-factory-airport",
      "poi_latitude": "37.694119",
      "poi_longitude": "-97.222706",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-49af-773f-b53a-6333eab4f1bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-49af-773f-b53a-6333eab4f1bd",
        "storage_key": "property/6767906449166548/019cfb4f-49af-773f-b53a-6333eab4f1bd.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJL2fuq2D8uocR3pXUsHIxYiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_09bb902f-ae91-466a-b8da-a764406eeed6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Koch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4111 E 37th St N, Wichita, KS 67220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-40d0-750f-a475-be7d3d247f74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-40d0-750f-a475-be7d3d247f74",
        "storage_key": "property/6767906449166548/019cfb4f-40d0-750f-a475-be7d3d247f74.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.kochinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12365933933611970858&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "koch",
      "poi_latitude": "37.7515586",
      "poi_longitude": "-97.2902548",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-828-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4654-7094-8cf0-e11f019e4544",
        "storage_key": "property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHTHmrtrjuocRKvHjJGWfnKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d7238ce5-7874-428e-850a-3dd48bfb57e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Cargill Protein Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "825 E Douglas Ave, Wichita, KS 67202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-732d-73de-bf46-eccd8ff67168.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-732d-73de-bf46-eccd8ff67168",
        "storage_key": "property/6767906449166548/019cfb4f-732d-73de-bf46-eccd8ff67168.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cargill.com/page/cargill-protein-hq",
      "poi_directions_map_url": "https://maps.google.com/?cid=1167281867094812957&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cargill-protein-headquarters",
      "poi_latitude": "37.6853999",
      "poi_longitude": "-97.3279603",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-291-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4654-7094-8cf0-e11f019e4544",
        "storage_key": "property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVWVDpXjuocRHenwcKwEMxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7d9a7801-9f60-49dd-830a-c3068c706fe8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Textron Aviation Career & Learning Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "293 S Greenwich Rd Suite 400, Wichita, KS 67206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://txtav.com/en/careers/career-learning-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=17738308330864323395&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "textron-aviation-career--learning-center",
      "poi_latitude": "37.6827328",
      "poi_longitude": "-97.2112662",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-515-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4654-7094-8cf0-e11f019e4544",
        "storage_key": "property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN6sjFQD9uocRQyuFAXIhK_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ab01686c-4f33-4f85-8ff3-263ba38ee3f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Airbus Americas Engineering",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1855 Innovation Blvd, Wichita, KS 67208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-7371-7218-b413-ddb8de9822ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-7371-7218-b413-ddb8de9822ab",
        "storage_key": "property/6767906449166548/019cfb4f-7371-7218-b413-ddb8de9822ab.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.airbus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2717662062190135635&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "airbus-americas-engineering",
      "poi_latitude": "37.717177",
      "poi_longitude": "-97.2864877",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-299-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4654-7094-8cf0-e11f019e4544",
        "storage_key": "property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw6cW5d3iuocRUwlmLD8TtyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6787d442-1a77-44c8-b1c8-700061da636b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Goodwill Industries of Kansas Administration & NexStep Alliance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3351 N Webb Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Long-standing nonprofit chain with a range of pre-owned clothing, furniture, housewares & more.",
      "poi_long_description": "Long-standing nonprofit chain with a range of pre-owned clothing, furniture, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-41e6-74e9-af9f-1de8b6cfa54c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4f-41e6-74e9-af9f-1de8b6cfa54c",
        "storage_key": "property/6767906449166548/019cfb4f-41e6-74e9-af9f-1de8b6cfa54c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://goodwillks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2600486553204831060&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "goodwill-industries-of-kansas-administration--nexstep-alliance",
      "poi_latitude": "37.744572",
      "poi_longitude": "-97.2273",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-744-9291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4654-7094-8cf0-e11f019e4544",
        "storage_key": "property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTXAYzXD9uocRVDP0_r3IFiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a8693c06-4d4e-4adc-85c6-c4f5c8451005",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Wichita Northeast Magnet High School",
      "poi_type": "Education",
      "poi_address": "5550 N Lycee St, Bel Aire, KS 67226, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://northeast.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15660671500643582661&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-northeast-magnet-high-school",
      "poi_latitude": "37.7849345",
      "poi_longitude": "-97.2386567",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-973-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4648-7558-9478-b8c8daf2fa76",
        "storage_key": "property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU3XdLukCu4cRxcLxi8HhVdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_586fb13b-1835-4609-aa93-45d826203469",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Gammon Elementary School",
      "poi_type": "Education",
      "poi_address": "3240 N Rushwood St, Wichita, KS 67226, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://gammon.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13503059042279022783&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gammon-elementary-school",
      "poi_latitude": "37.7417843",
      "poi_longitude": "-97.2553336",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-973-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4648-7558-9478-b8c8daf2fa76",
        "storage_key": "property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6xGEZ0_9uocRv-AqHKiAZLs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_03f78438-27f0-457e-b0be-5e2334fc507e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Stucky",
      "poi_type": "Education",
      "poi_address": "4545 Broadview Cir, Wichita, KS 67220, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://stucky.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2851284141479440007&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "stucky",
      "poi_latitude": "37.76438",
      "poi_longitude": "-97.288085",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-973-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4648-7558-9478-b8c8daf2fa76",
        "storage_key": "property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFxUNDWgdu4cRhy6W5tHLkSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e22366da-d62a-49b9-b9ab-b6f41b1c6079",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Friends University",
      "poi_type": "Education",
      "poi_address": "2100 W Univ Ave, Wichita, KS 67213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7915-b9f1-772b-99e8-bd98bca0b35a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-b9f1-772b-99e8-bd98bca0b35a",
        "storage_key": "property/6767906449166548/019d7915-b9f1-772b-99e8-bd98bca0b35a.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "http://www.friends.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15570531106663261673&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "friends-university",
      "poi_latitude": "37.6777089",
      "poi_longitude": "-97.3666702",
      "poi_miles_from_property": "10.5 mi",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 316-295-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4648-7558-9478-b8c8daf2fa76",
        "storage_key": "property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV-zLPUThuocR6WXVmIujFdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b592be97-db91-495e-9b5f-eb3bbfc47193",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Wichita Heights High School",
      "poi_type": "Education",
      "poi_address": "5301 N Hillside St, Wichita, KS 67219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.usd259.org/Heights",
      "poi_directions_map_url": "https://maps.google.com/?cid=1845228234757208164&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-heights-high-school",
      "poi_latitude": "37.7797355",
      "poi_longitude": "-97.3001917",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-973-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4648-7558-9478-b8c8daf2fa76",
        "storage_key": "property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe09kRQkdu4cRZHg5lk2Rmxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_caa3bf01-310e-4f7e-ba37-0a63a083ad4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Newman University",
      "poi_type": "Education",
      "poi_address": "3100 McCormick St, Wichita, KS 67213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7915-b762-708f-a400-b7f7abfd65ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-b762-708f-a400-b7f7abfd65ee",
        "storage_key": "property/6767906449166548/019d7915-b762-708f-a400-b7f7abfd65ee.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.newmanu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8197001651856080544&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "newman-university",
      "poi_latitude": "37.673508",
      "poi_longitude": "-97.377744",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 12 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 316-942-4291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4648-7558-9478-b8c8daf2fa76",
        "storage_key": "property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjRoRMzHhuocRoP4ropKZwXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3b742f65-31ca-4da7-ada2-78c9a4a16940",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Wichita Collegiate School",
      "poi_type": "Education",
      "poi_address": "9115 E 13th St N, Wichita, KS 67206, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7915-b71e-743f-9494-1c9b55919155.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-b71e-743f-9494-1c9b55919155",
        "storage_key": "property/6767906449166548/019d7915-b71e-743f-9494-1c9b55919155.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.wcsks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6161546641279598679&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-collegiate-school",
      "poi_latitude": "37.7070832",
      "poi_longitude": "-97.2314664",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-634-0433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4648-7558-9478-b8c8daf2fa76",
        "storage_key": "property/6767906449166548/019cfb4f-4648-7558-9478-b8c8daf2fa76.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMeE4GPv8uocRV8B4ZAY2glU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_42effa02-f627-4ed3-831a-3d108b27ba54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Mulligan's Pub",
      "poi_type": "Restaurants",
      "poi_address": "8343 E 32nd St N, Wichita, KS 67226, USA",
      "poi_short_description": "Casual pub with a jukebox, beer selection, and pizza, plus trivia nights and karaoke.",
      "poi_long_description": "People say this restaurant offers good food, including a cheeseburger pizza, and well-priced drinks. They also highlight the friendly staff, welcoming atmosphere, and fun karaoke.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7915-b6ba-723e-b000-e17140e46d3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-b6ba-723e-b000-e17140e46d3b",
        "storage_key": "property/6767906449166548/019d7915-b6ba-723e-b000-e17140e46d3b.webp",
        "width": 764,
        "height": 530
      },
      "poi_business_url": "http://mulligansict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12212648157130127538&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mulligan-s-pub",
      "poi_latitude": "37.742511",
      "poi_longitude": "-97.240161",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-636-2220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464d-75b2-9fec-7e3a1617e0cb",
        "storage_key": "property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYXWGD2n9uocRsviRJMsKfKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_bd38af62-ad4c-4135-bb4f-dc06b7c3da24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Napoli Italian Eatery",
      "poi_type": "Restaurants",
      "poi_address": "7718 E 37th St N, Wichita, KS 67226, USA",
      "poi_short_description": "Casual cafe featuring handmade pastas, pizzas, and lasagna, alongside Italian classics.",
      "poi_long_description": "People say this restaurant serves delicious calamari, pasta Alfredo with chicken, and homemade pasta dishes like Spaghetti Nero and Orecchiette. They highlight the generous portions, authentic Italian flavors, and the fun, casually elegant, contemporary atmosphere. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7915-d188-7095-97dc-ed3a905cd198.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d188-7095-97dc-ed3a905cd198",
        "storage_key": "property/6767906449166548/019d7915-d188-7095-97dc-ed3a905cd198.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.napoliwichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13459347614404449876&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "napoli-italian-eatery",
      "poi_latitude": "37.7528944",
      "poi_longitude": "-97.2476268",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 316-260-5859",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464d-75b2-9fec-7e3a1617e0cb",
        "storage_key": "property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRSkjphb9uocRVBYUOVg1ybo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d74822c4-4064-4c47-aa72-2e69fffb278f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Jumbo's Beef & Brew",
      "poi_type": "Restaurants",
      "poi_address": "3750 N Woodlawn Blvd Ste 102, Wichita, KS 67220, USA",
      "poi_short_description": "Plaid-walled spot dishing up juicy burgers and wings along with beer and cocktails.",
      "poi_long_description": "People say this restaurant serves delicious burgers, Italian beef sandwiches, and wings. They highlight the generous portions, tasty sauces, and the unique jalapeño poppers. They also like the friendly service and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7915-c367-749d-bc96-21b5f1bd0090.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-c367-749d-bc96-21b5f1bd0090",
        "storage_key": "property/6767906449166548/019d7915-c367-749d-bc96-21b5f1bd0090.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jumbosbeef.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2549702353531799005&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jumbo-s-beef-brew",
      "poi_latitude": "37.7509959",
      "poi_longitude": "-97.2616654",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-358-0407",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464d-75b2-9fec-7e3a1617e0cb",
        "storage_key": "property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX_smuon9uocR3YU9GchcYiM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d9da3289-83b7-4191-b5b5-38d077e2c855",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Thai Table Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "3570 N Woodlawn Blvd #100, Wichita, KS 67220, USA",
      "poi_short_description": "Casual Thai food spot (plus beer and wine) serving up classic specialties such as pad thai and curry, plus vegan options and fresh ingredients.",
      "poi_long_description": "People say this restaurant serves delicious and authentic Thai food, including curries, pad Thai, and drunken noodles. They highlight the generous portions, fresh ingredients, and reasonable prices. They also like the clean, comfortable, and relaxing atmosphere, and the friendly, attentive, and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7915-c4fc-71cb-94ea-85a7424935fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-c4fc-71cb-94ea-85a7424935fb",
        "storage_key": "property/6767906449166548/019d7915-c4fc-71cb-94ea-85a7424935fb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://thaitablewichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16302132865108929894&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "thai-table-restaurant",
      "poi_latitude": "37.7487011",
      "poi_longitude": "-97.261746",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-978-9998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464d-75b2-9fec-7e3a1617e0cb",
        "storage_key": "property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeYOUc2f9uocRZu0J6nfPPOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c5212a9a-7dd2-4f76-b638-b27626f579a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Mirai ramen & sushi",
      "poi_type": "Restaurants",
      "poi_address": "6254 E 37th St N Suite #180, Wichita, KS 67220, USA",
      "poi_short_description": "Casual restaurant serving a menu of Japanese fare such as ramen and sushi.",
      "poi_long_description": "People say this Japanese restaurant serves delicious ramen, sushi, and hibachi. They highlight the fresh, flavorful, and beautifully prepared dishes, and the cozy, inviting atmosphere. They also like the friendly, attentive service and the fast food delivery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7915-d1b6-713e-8e38-5b6f1fe300bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d1b6-713e-8e38-5b6f1fe300bb",
        "storage_key": "property/6767906449166548/019d7915-d1b6-713e-8e38-5b6f1fe300bb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mirairamensushiks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7496437929740053560&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mirai-ramen-sushi",
      "poi_latitude": "37.7527656",
      "poi_longitude": "-97.2640952",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-295-3677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464d-75b2-9fec-7e3a1617e0cb",
        "storage_key": "property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv1_4LG_9uocROKzrSpSyCGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_9b1bdc99-8860-40c9-8035-9e1ec69b8678",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Tacos TJ 664 East",
      "poi_type": "Restaurants",
      "poi_address": "3526 N Rock Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Tacos, burritos, and other Mexican plates served in a laid-back spot.",
      "poi_long_description": "People say this Mexican restaurant serves delicious tacos, burritos, quesadillas, and birria dishes. They highlight the generous portions, reasonable prices, and authentic flavors. They also like the fast service and clean, orderly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7915-d6ac-7258-b6c0-1ac3377f5847.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d6ac-7258-b6c0-1ac3377f5847",
        "storage_key": "property/6767906449166548/019d7915-d6ac-7258-b6c0-1ac3377f5847.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://tacostj664.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5965861651601279263&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tacos-tj-664-east",
      "poi_latitude": "37.74838",
      "poi_longitude": "-97.2442114",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-665-3320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464d-75b2-9fec-7e3a1617e0cb",
        "storage_key": "property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0bEyAfP9uocRH8nRSpD_ylI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_a2bf6e7b-5223-424d-830b-b1992679d6cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Carrabba's Italian Grill",
      "poi_type": "Restaurants",
      "poi_address": "3409 N Rock Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Chain eatery & bar serving a diverse menu of classic Italian fare in a family-friendly setting.",
      "poi_long_description": "People say this Italian restaurant serves delicious food, including Tuscan filet, lobster ravioli, and chicken parmesan. They highlight the generous portions, the $10 take-home meal deal, and the fun wine dinners. They also like the attentive, knowledgeable, and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7915-d825-758a-baa2-5eadc4c7e497.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d825-758a-baa2-5eadc4c7e497",
        "storage_key": "property/6767906449166548/019d7915-d825-758a-baa2-5eadc4c7e497.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.carrabbas.com/kansas/wichita/3409-north-rock-road?y_source=1_MTU1MDMwNTYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2409516887512993460&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "carrabba-s-italian-grill",
      "poi_latitude": "37.7453909",
      "poi_longitude": "-97.2472728",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-315-0777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464d-75b2-9fec-7e3a1617e0cb",
        "storage_key": "property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc_ADy1z9uocRtE6E0NdScCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_fb6b33b1-e306-4a9c-aabe-85fdfa3dff34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "City Bites",
      "poi_type": "Restaurants",
      "poi_address": "3570 N Woodlawn Blvd # 500 # 500, Wichita, KS 67220, USA",
      "poi_short_description": "Casual deli chain featuring sandwiches & wraps, plus baked potatoes with toppings.",
      "poi_long_description": "People say this deli serves up delicious sandwiches, including the Philly cheesesteak and Fleetwood. They also highlight the friendly staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7915-e3c3-762a-af73-8772d1e72b7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-e3c3-762a-af73-8772d1e72b7b",
        "storage_key": "property/6767906449166548/019d7915-e3c3-762a-af73-8772d1e72b7b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.citybites.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5976657895777532390&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "city-bites",
      "poi_latitude": "37.7489617",
      "poi_longitude": "-97.2616953",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-682-0007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464e-7424-ba06-0830dda56889",
        "storage_key": "property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJx3XPoVP9uocR5nnaxbBa8VI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "deli"
    },
    {
      "id": "custom_fbd7f313-ac00-4b94-8b5e-bfa37f756677",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "HomeGrown Wichita - Bradley Fair",
      "poi_type": "Restaurants",
      "poi_address": "1900 N Rock Rd #108, Wichita, KS 67206, USA",
      "poi_short_description": "Casual, locally sourced brunch cafe (often serving breakfast food).",
      "poi_long_description": "People say this breakfast restaurant serves fresh, delicious food prepared with care, including dishes like brussel sprouts, sweet potatoes, and a three-meat platter. They highlight the great value, the energetic and welcoming atmosphere, and the friendly and attentive staff. They also like the fast and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7915-e52a-73a2-a9c1-42f7593e071f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-e52a-73a2-a9c1-42f7593e071f",
        "storage_key": "property/6767906449166548/019d7915-e52a-73a2-a9c1-42f7593e071f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homegrownkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5277230365346679362&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "homegrown-wichita-bradley-fair",
      "poi_latitude": "37.7182208",
      "poi_longitude": "-97.2427204",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-247-9611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464d-75b2-9fec-7e3a1617e0cb",
        "storage_key": "property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnQ5djRv9uocRQspkrA59PEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_5bfb76b9-86c5-44e1-a86d-8a901b2ccb53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "The Easy Egg Breakfast & Lunch",
      "poi_type": "Restaurants",
      "poi_address": "3130 N Rock Rd #100, Wichita, KS 67226, USA",
      "poi_short_description": "Casual cafe popular for pancakes and other breakfast plates, plus brunch and lunch options.",
      "poi_long_description": "Diners say this breakfast restaurant serves up delicious omelets, hash browns, and pancakes, and they praise the chicken fried steak and Nutella crepes. They also highlight the friendly and attentive staff, and the clean and inviting atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7915-f4e5-75fb-ba25-a51c4e8629ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f4e5-75fb-ba25-a51c4e8629ae",
        "storage_key": "property/6767906449166548/019d7915-f4e5-75fb-ba25-a51c4e8629ae.webp",
        "width": 944,
        "height": 1280
      },
      "poi_business_url": "https://theeasyeggbreakfast.com/theeasyeggbreakfastlunch-fft2i9?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=6702781086145211681&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-easy-egg-breakfast-lunch",
      "poi_latitude": "37.7399657",
      "poi_longitude": "-97.2438158",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-352-7237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464d-75b2-9fec-7e3a1617e0cb",
        "storage_key": "property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJa327AwD9uocRIW3kjuIPBV0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_4948877f-202b-4097-a63d-e0847876d3df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Astoria Indian Grill",
      "poi_type": "Restaurants",
      "poi_address": "3242 N Rock Rd suite #118, Wichita, KS 67226, USA",
      "poi_short_description": "Indian restaurant offering an all-you-can-eat option for breakfast, lunch, and dinner.",
      "poi_long_description": "People say this Indian restaurant serves authentic southern Indian dishes, including chicken tikka masala, amaravati, and butter chicken. They highlight the affordable prices and cozy, inviting atmosphere. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7915-f4ae-7349-ace6-f165205e8518.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f4ae-7349-ace6-f165205e8518",
        "storage_key": "property/6767906449166548/019d7915-f4ae-7349-ace6-f165205e8518.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.astoriawichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5374253998438923719&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "astoria-indian-grill",
      "poi_latitude": "37.7419302",
      "poi_longitude": "-97.2433139",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-351-5544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464d-75b2-9fec-7e3a1617e0cb",
        "storage_key": "property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKSLYsKX9uocRx72snYkvlUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_78b8c24b-2bf4-4d55-878c-51a1d0797a3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Redrock Canyon Grill - Wichita",
      "poi_type": "Restaurants",
      "poi_address": "1844 N Rock Rd, Wichita, KS 67206, USA",
      "poi_short_description": "Easygoing bistro & bar turning out wood-fired rotisserie chicken & Southwest-inspired dishes.",
      "poi_long_description": "Diners say this American restaurant serves up delicious salmon, meatloaf, and key lime pie, and they praise the cocktails. They also highlight the excellent service and comfortable patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7915-f3c1-764a-83da-2bfb989c68d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f3c1-764a-83da-2bfb989c68d0",
        "storage_key": "property/6767906449166548/019d7915-f3c1-764a-83da-2bfb989c68d0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.redrockcanyongrill.com/locations/redrock-canyon-grill-wichita/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3489919413144966016&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "redrock-canyon-grill-wichita",
      "poi_latitude": "37.7173429",
      "poi_longitude": "-97.2439943",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-636-1844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464d-75b2-9fec-7e3a1617e0cb",
        "storage_key": "property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH08HfB_9uocRgNM-QzevbjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_1d08f788-6cd8-4784-b40f-f358c6c4ebad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "10800 E 21st St N, Wichita, KS 67206, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store has a wide selection of products. They also highlight the kind and courteous employees, and the minimal checkout time.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7915-f521-70be-a0ea-c84eb23f7016.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f521-70be-a0ea-c84eb23f7016",
        "storage_key": "property/6767906449166548/019d7915-f521-70be-a0ea-c84eb23f7016.webp",
        "width": 1140,
        "height": 749
      },
      "poi_business_url": "https://www.target.com/sl/wichita-ne/1944",
      "poi_directions_map_url": "https://maps.google.com/?cid=6067598449320791704&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "37.724525",
      "poi_longitude": "-97.2123712",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-636-4206",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464e-7424-ba06-0830dda56889",
        "storage_key": "property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJazbbMa79uocRmA56Y6RwNFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_ea49acad-e119-4034-9129-598c79cb8c81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Kirkland's Home",
      "poi_type": "Shopping & Retail",
      "poi_address": "New Market Square, 2441 N Maize Rd, Wichita, KS 67205, USA",
      "poi_short_description": "Retail chain with a wide assortment of home-decor items & gifts, including pillows, art & bedding.",
      "poi_long_description": "Retail chain with a wide assortment of home-decor items & gifts, including pillows, art & bedding.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7915-fff5-7078-acdb-e74945aaf9ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-fff5-7078-acdb-e74945aaf9ae",
        "storage_key": "property/6767906449166548/019d7915-fff5-7078-acdb-e74945aaf9ae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kirklands.com/custserv/store.jsp?storeName=New%20Market%20Square",
      "poi_directions_map_url": "https://maps.google.com/?cid=11214056814465920333&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kirkland-s-home",
      "poi_latitude": "37.7295523",
      "poi_longitude": "-97.4662826",
      "poi_miles_from_property": "14.7 mi",
      "poi_walking_minutes": "5 hours 22 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 316-722-1676",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464e-7424-ba06-0830dda56889",
        "storage_key": "property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJy7Iw4pPfuocRTS1KFUJVoJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_e42b587c-4d9f-42c3-bb9c-c12b28cd7bdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Marshalls",
      "poi_type": "Shopping & Retail",
      "poi_address": "2676 N Greenwich Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_long_description": "People say this department store offers a wide variety of clothing, shoes, and home goods. They also highlight the great finds and good value.\n\nSome reviews mention the store can be disorganized.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7916-02c9-75d8-8dbb-c70f37bebfe0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-02c9-75d8-8dbb-c70f37bebfe0",
        "storage_key": "property/6767906449166548/019d7916-02c9-75d8-8dbb-c70f37bebfe0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.marshalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4113220268239433872&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "marshalls",
      "poi_latitude": "37.7316697",
      "poi_longitude": "-97.2026217",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-315-0232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464e-7424-ba06-0830dda56889",
        "storage_key": "property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP4LuvZ_9uocRkDBZiwoYFTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_3e88f36a-e864-4370-86c3-e5a0b7438351",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Under Armour Factory House - Greenwich Place",
      "poi_type": "Shopping & Retail",
      "poi_address": "2696 N Greenwich Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Activewear brand known for its apparel, shoes & accessories designed for sports & fitness.",
      "poi_long_description": "Activewear brand known for its apparel, shoes & accessories designed for sports & fitness.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7916-00ea-7434-b4bf-148620a07198.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-00ea-7434-b4bf-148620a07198",
        "storage_key": "property/6767906449166548/019d7916-00ea-7434-b4bf-148620a07198.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.underarmour.com/en-us/stores/detail/WICHI-2716NGRWK-1/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10585164771719971158&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "under-armour-factory-house-greenwich-place",
      "poi_latitude": "37.7317079",
      "poi_longitude": "-97.2070652",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-771-5843",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464e-7424-ba06-0830dda56889",
        "storage_key": "property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP2dp3C79uocRVgFZ-0YP5pI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_b46240e4-6397-4671-86d2-a848546b3033",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "2716 N Greenwich Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_long_description": "People say this department store offers a wide variety of unique and interesting home goods, with new items appearing regularly. They highlight the reasonable prices and the fun, treasure hunt-like shopping experience. They also like the well-organized layout and the kind staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7916-00f5-7539-9301-0d00672fe209.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-00f5-7539-9301-0d00672fe209",
        "storage_key": "property/6767906449166548/019d7916-00f5-7539-9301-0d00672fe209.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.homegoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2623202061790853438&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "homegoods",
      "poi_latitude": "37.7331936",
      "poi_longitude": "-97.2029482",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-630-0374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464e-7424-ba06-0830dda56889",
        "storage_key": "property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5VEhP5z9uocRPrkde2B8ZyQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_a082a6da-17e4-4b15-98ac-6c996e10ab9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Willowbend Golf Club",
      "poi_type": "Entertainment",
      "poi_address": "8001 E Mulberry Dr, Wichita, KS 67226, USA",
      "poi_short_description": "Nine-hole golf course with water hazards, sand bunkers, and multiple tee options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7916-096b-7375-9d16-c838a4ad4e21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-096b-7375-9d16-c838a4ad4e21",
        "storage_key": "property/6767906449166548/019d7916-096b-7375-9d16-c838a4ad4e21.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://willowbendgolfclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13312044814843216547&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "willowbend-golf-club",
      "poi_latitude": "37.759144",
      "poi_longitude": "-97.2438684",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-636-4653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-467e-7569-a2cb-aac66f35ea64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-467e-7569-a2cb-aac66f35ea64",
        "storage_key": "property/6767906449166548/019cfb4f-467e-7569-a2cb-aac66f35ea64.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJsbzUxqECu4cRo4LPljrivbg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_ec5f69a9-36a0-4c6b-aa51-224805ded4ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "AMC Northrock 14",
      "poi_type": "Entertainment",
      "poi_address": "3151 N Penstemon St, Wichita, KS 67226, USA",
      "poi_short_description": "Movie theater chain with a variety of amenities, including reclining seats and 3D movies.",
      "poi_long_description": "People say this movie theater offers comfortable reclining seats and a good selection of concessions. They also highlight the clean theaters, friendly staff, and powerful sound system.\n\nOther reviews mention the concession prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7916-0794-707e-a9ca-11330e67cb19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-0794-707e-a9ca-11330e67cb19",
        "storage_key": "property/6767906449166548/019d7916-0794-707e-a9ca-11330e67cb19.webp",
        "width": 1280,
        "height": 833
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/wichita/amc-northrock-14?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13529197710045147743&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amc-northrock-14",
      "poi_latitude": "37.740462",
      "poi_longitude": "-97.240899",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-221-7267",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7916-27be-777e-8d62-b8bb1b3ce3d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7916-27be-777e-8d62-b8bb1b3ce3d3",
        "storage_key": "property/6767906449166548/019d7916-27be-777e-8d62-b8bb1b3ce3d3.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJPQ2wKmr9uocRX_JE86Jdwbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_2c46fdc4-1d18-43d6-8b4a-620f5f06ee2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Botanica, The Wichita Gardens",
      "poi_type": "Entertainment",
      "poi_address": "701 Amidon St, Wichita, KS 67203, USA",
      "poi_short_description": "Imaginative, verdant botanical garden with children's areas, a butterfly house, events & more.",
      "poi_long_description": "People say this botanical garden offers beautiful gardens, a butterfly house, and a children's area with a carousel and playground. They highlight the tranquil and peaceful atmosphere, and the well-maintained grounds with labeled plants and artistic sculptures. They also like the fun and engaging activities for children, such as the splash area and treehouse.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7916-1039-760f-a9e1-d3b51fe0e271.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-1039-760f-a9e1-d3b51fe0e271",
        "storage_key": "property/6767906449166548/019d7916-1039-760f-a9e1-d3b51fe0e271.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.botanica.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14898597451770473856&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "botanica-the-wichita-gardens",
      "poi_latitude": "37.6964308",
      "poi_longitude": "-97.361781",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 316-264-0448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4654-7094-8cf0-e11f019e4544",
        "storage_key": "property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeda7xm_huocRgK1RPHJzws4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_f400d44b-e5fc-4374-9947-5f2486cbe754",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Sedgwick County Zoo",
      "poi_type": "Entertainment",
      "poi_address": "5555 W Zoo Blvd, Wichita, KS 67212, USA",
      "poi_short_description": "Animals organized by continent, plus educational programs for various age groups.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including baby elephants, and has spacious, well-designed habitats that mimic natural environments. They highlight the zoo is clean, well-organized, and easy to navigate, with plenty of rest areas and shaded spots. They also like the friendly, knowledgeable, and passionate staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7916-0a70-702b-95ed-5da8ea12b3cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-0a70-702b-95ed-5da8ea12b3cf",
        "storage_key": "property/6767906449166548/019d7916-0a70-702b-95ed-5da8ea12b3cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://scz.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11432857233417595508&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sedgwick-county-zoo",
      "poi_latitude": "37.717034",
      "poi_longitude": "-97.408561",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 316-660-9453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4654-7094-8cf0-e11f019e4544",
        "storage_key": "property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDVutukTguocRdGqcdRSrqZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_dbed597f-7ca1-4a33-a6db-eb18ace84d9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Bowlero Northrock",
      "poi_type": "Entertainment",
      "poi_address": "3232 N Rock Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Bowling alley & arcade games.",
      "poi_long_description": "People say this bowling alley offers a wide selection of lanes, bowling balls, and shoes, and has a restaurant with plenty of food options. They also highlight the friendly and helpful staff, and the fun and spacious atmosphere.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7916-1032-73d9-9545-dbcf3ee9e729.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-1032-73d9-9545-dbcf3ee9e729",
        "storage_key": "property/6767906449166548/019d7916-1032-73d9-9545-dbcf3ee9e729.webp",
        "width": 1280,
        "height": 500
      },
      "poi_business_url": "https://www.bowlero.com/location/bowlero-northrock?utm_source=gbp&utm_medium=organic&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=5451703492999555049&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bowlero-northrock",
      "poi_latitude": "37.7404433",
      "poi_longitude": "-97.2424088",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-636-5444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4654-7094-8cf0-e11f019e4544",
        "storage_key": "property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ52Uf9Gn9uocR6af-SHFXqEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_c415b20e-0d67-4e3d-a6bd-68d2cef73a7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Wichita Sports Forum",
      "poi_type": "Entertainment",
      "poi_address": "2668 N Greenwich Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Trampoline area with several foam pits, plus sand volleyball, basketball and soccer courts.",
      "poi_long_description": "People say this sports complex offers a variety of activities, including basketball, volleyball, and a trampoline park. They also highlight the fun atmosphere and the friendly, helpful staff.\n\nSome reviews mention the facilities can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7916-1078-733a-84af-8883f591116e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-1078-733a-84af-8883f591116e",
        "storage_key": "property/6767906449166548/019d7916-1078-733a-84af-8883f591116e.webp",
        "width": 1280,
        "height": 457
      },
      "poi_business_url": "http://wichitasportsforum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=290413582065142880&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-sports-forum",
      "poi_latitude": "37.7324621",
      "poi_longitude": "-97.1999983",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-201-1414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4654-7094-8cf0-e11f019e4544",
        "storage_key": "property/6767906449166548/019cfb4f-4654-7094-8cf0-e11f019e4544.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4bsAl7v9uocRYAzxPJ3BBwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_bc37fd2e-557b-4cfe-a2b6-d41c6815abcf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Dave & Buster's Wichita",
      "poi_type": "Entertainment",
      "poi_address": "2644 N Greenwich Ct, Wichita, KS 67226, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "People say this restaurant offers a wide variety of games and virtual reality experiences, making it a fun place for kids and adults. They also highlight the friendly staff and the fun, lively atmosphere, especially for birthday parties.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7916-14cb-7590-950e-f09d6c83cfef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-14cb-7590-950e-f09d6c83cfef",
        "storage_key": "property/6767906449166548/019d7916-14cb-7590-950e-f09d6c83cfef.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/wichita",
      "poi_directions_map_url": "https://maps.google.com/?cid=7654772984293764890&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dave-buster-s-wichita",
      "poi_latitude": "37.7301016",
      "poi_longitude": "-97.2016028",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-796-8550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464d-75b2-9fec-7e3a1617e0cb",
        "storage_key": "property/6767906449166548/019cfb4f-464d-75b2-9fec-7e3a1617e0cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVR9GjIL9uocRGi8W9Xg3O2o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_19971eaf-64c1-4058-8861-2c9ce1e85d04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Old Cowtown Museum",
      "poi_type": "Entertainment",
      "poi_address": "1865 Museum Blvd, Wichita, KS 67203, USA",
      "poi_short_description": "Re-creation of late-1880s life in the County, including farm animals, photos & document archives.",
      "poi_long_description": "People say this museum offers a fun and educational experience with live demonstrations, interactive exhibits, and a glimpse into the past. They highlight the self-paced tours, the opportunity to explore historic buildings, and the entertaining gunfights and shows. They also like the knowledgeable and friendly staff and volunteers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7916-1724-7227-9ad7-ad0f46dd1ca3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-1724-7227-9ad7-ad0f46dd1ca3",
        "storage_key": "property/6767906449166548/019d7916-1724-7227-9ad7-ad0f46dd1ca3.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.oldcowtown.org/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13259083149142063349&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-cowtown-museum",
      "poi_latitude": "37.6936698",
      "poi_longitude": "-97.3601599",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 316-350-3323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4642-70fb-871a-ed79d2d78011.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4642-70fb-871a-ed79d2d78011",
        "storage_key": "property/6767906449166548/019cfb4f-4642-70fb-871a-ed79d2d78011.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJYYk8gGThuocR9fj639-5Abg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_29c94183-8dee-455e-8fc9-3a7ce702ce80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Exploration Place",
      "poi_type": "Entertainment",
      "poi_address": "300 N McLean Blvd, Wichita, KS 67203, USA",
      "poi_short_description": "Exhibits, films, live shows, & hands-on science & discovery programs for kids and adults.",
      "poi_long_description": "People say this science museum offers interactive exhibits, a shark exhibit, and a dome theater. They highlight the educational and entertaining experience, and the fun, hands-on activities for kids and adults. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7916-1823-729f-851e-114b9b191e83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-1823-729f-851e-114b9b191e83",
        "storage_key": "property/6767906449166548/019d7916-1823-729f-851e-114b9b191e83.webp",
        "width": 1280,
        "height": 745
      },
      "poi_business_url": "http://www.exploration.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14209503253032261092&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "exploration-place",
      "poi_latitude": "37.6894665",
      "poi_longitude": "-97.3479609",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 316-660-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4642-70fb-871a-ed79d2d78011.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4642-70fb-871a-ed79d2d78011",
        "storage_key": "property/6767906449166548/019cfb4f-4642-70fb-871a-ed79d2d78011.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJE7tm5d7juocR5NW-Z-xLMsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b02dc139-4602-4d02-a843-7d4f80139074",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Big Arkansas river Park",
      "poi_type": "Entertainment",
      "poi_address": "2132 N McComas St, Wichita, KS 67203, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7916-1e56-707f-94bc-9ed4ba0dcd26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-1e56-707f-94bc-9ed4ba0dcd26",
        "storage_key": "property/6767906449166548/019d7916-1e56-707f-94bc-9ed4ba0dcd26.webp",
        "width": 424,
        "height": 473
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6019610997665195500&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "big-arkansas-river-park",
      "poi_latitude": "37.724049",
      "poi_longitude": "-97.3866092",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4642-70fb-871a-f370702c2845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4642-70fb-871a-f370702c2845",
        "storage_key": "property/6767906449166548/019cfb4f-4642-70fb-871a-f370702c2845.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtbEkNgDhuocR7GXeIU_0iVM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4e27c7e2-c271-4285-aa59-e763221c2584",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Bondie's Old Town Antique Mall",
      "poi_type": "Entertainment",
      "poi_address": "827 E Central Ave, Wichita, KS 67202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7916-20fc-709d-9aaf-4a258cb4078d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-20fc-709d-9aaf-4a258cb4078d",
        "storage_key": "property/6767906449166548/019d7916-20fc-709d-9aaf-4a258cb4078d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://bondies-mall.poi.place/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4072456949025361141&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bondie-s-old-town-antique-mall",
      "poi_latitude": "37.693311",
      "poi_longitude": "-97.3277589",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-267-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-464e-7424-ba06-0830dda56889",
        "storage_key": "property/6767906449166548/019cfb4f-464e-7424-ba06-0830dda56889.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLfhW17jjuocR9Uy6sQRGhDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_9e03525c-be35-49d6-80c8-b43f7e3a2e30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "poi_name": "Veterans Memorial Park",
      "poi_type": "Entertainment",
      "poi_address": "339 Veterans Pkwy, Wichita, KS 67203, USA",
      "poi_short_description": "Green space on the Arkansas River featuring 7 memorials honoring US veterans & Gold Star mothers.",
      "poi_long_description": "People say this memorial park is a beautiful place to reflect and honor those who served. They highlight the well-maintained grounds, the dedication to all conflicts, and the nightly burn ceremony. They also like the safe, family-friendly atmosphere with bright lighting and police presence.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d7916-1f61-73c9-9e81-23b17cd676a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-1f61-73c9-9e81-23b17cd676a1",
        "storage_key": "property/6767906449166548/019d7916-1f61-73c9-9e81-23b17cd676a1.webp",
        "width": 1032,
        "height": 774
      },
      "poi_business_url": "https://wichitaveteransmemorialpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14215014086042975862&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "veterans-memorial-park",
      "poi_latitude": "37.6906041",
      "poi_longitude": "-97.3449733",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 316-219-9777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-4642-70fb-871a-f370702c2845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4f-4642-70fb-871a-f370702c2845",
        "storage_key": "property/6767906449166548/019cfb4f-4642-70fb-871a-f370702c2845.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0cJDE9zjuocRdv7DM__fRcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    }
  ],
  "office_hours": [
    {
      "id": "ec_1484eb5dad0f987ed83763a8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_d2b340dbd37ab20e83fe5ad8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_214ec050e6da4d2c89a95840",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_94467d618a3bce65d76c6573",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_1b5b1d60fd23e5c9fe155730",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_468575915501829522e4030c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_f4e02cb1-f03e-420c-89c8-397a734ff08a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "rating": "5.0",
      "name": "Rachel Thomas",
      "text": "This is literally the best place I’ve ever lived! My boyfriend and I moved in at the end of July and let me say the moving process was so easy with Remington! There was a super sweet gift basket on the counter and bottled water in the fridge. The place was SPOTLESS clean, and I could tell they really put effort into making it a new home for us. We’ve had a few maintenance requests but they’ve never taken more than 48 hours to be responded to and fixed. I love the maintenance team and how kind and professional they are. The property is always well maintained and this place just really feels like home! I never wanna live anywhere else!",
      "date": "2022-09-09",
      "title": ""
    },
    {
      "id": "custom_91e7c2cc-62cd-48a2-862d-9834ff3e5cdd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "rating": "5.0",
      "name": "Jonna Burton",
      "text": "Loved living here. staff was always so helpful and kind. They stayed on top of everything. They made every process easy and enjoyable! Even the ppl who live here are nice as well . I would definitely recommend the Remington apartments.",
      "date": "2025-07-02",
      "title": ""
    },
    {
      "id": "custom_92b24498-727f-4201-9b4b-6665a0defa79",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "rating": "5.0",
      "name": "Monique Manna",
      "text": "I absolutely love this community! From the office personnel to maintenance they have ensured a very safe community, are very responsive, friendly and supportive. During the winter months with all the snow, Case Management ensured the safety of everyone. I am disabled and those who shoveled made sure they cleared a way for me to walk safely. If I could give 10 stars I would! They go above and beyond!",
      "date": "2025-05-09",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_4cb70ed0-0a22-4811-928c-7f9a35691324",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-9d69-7187-a65a-e138050ded85.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of apartment complex pool and buildings",
        "public_id": "019cfb4f-9d69-7187-a65a-e138050ded85",
        "storage_key": "property/6767906449166548/019cfb4f-9d69-7187-a65a-e138050ded85.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Remington (Wichita) Virtual Tour",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=5f43e7cf8ff20846d0c87ede"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a03b5-18c6-730b-84ce-32f8eab05a16",
      "lead_source": "LANDING_PAGE",
      "name": "case-remington-wichita-lp",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548"
    },
    {
      "lead_collector_id": "019cf79d-419a-77ce-9b7b-4bfbb49e8fee",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "remington-wichita-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-wichita-ks",
      "search_query": "pet friendly apartments wichita ks",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Wichita, KS",
      "h2_subtitle": "Discover pet friendly living at Remington Wichita. Enjoy spacious homes and amenities perfect for you and your furry friend in vibrant Wichita, KS.",
      "page_copy": "Welcome to Remington Wichita, where pet friendly apartments in Wichita, KS, redefine comfort and convenience. Located in the vibrant Northeast Wichita area, our community offers expansive one- and two-bedroom layouts perfect for you and your furry companion. With amenities like a picnic area and quick access to I-35, enjoy fun-filled weekends and easy commutes.\n\nOur pet friendly atmosphere doesn't just stop at the door. Take advantage of walking trails around Sedgwick County or relax by our outdoor swimming pool while your pet lounges on a private patio or balcony. At Remington Wichita, modern living meets ultimate pet comfort, ensuring you and your pet feel right at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
      "featured_image_media": {
        "alt_text": "The Remington Apartments logo",
        "public_id": "019cfb4e-be95-73eb-98fe-0635e230a873",
        "storage_key": "property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
        "width": 1500,
        "height": 357
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Wichita, KS",
      "seo_description": "Explore Remington Wichita's pet friendly apartments. Spacious layouts and amenities just right for you and your furry friends in Wichita, KS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "generator",
      "page_item_url": "apartments-with-pool-sedgwick-county",
      "search_query": "apartments with a pool sedgwick county",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Sedgwick County",
      "h2_subtitle": "Enjoy Remington Wichita's luxurious pool. Discover the best apartments with a pool in Sedgwick County and enhance your vibrant lifestyle.",
      "page_copy": "Dive into comfort and style at Remington Wichita, offering apartments with a pool in Sedgwick County. Our community lets you unwind and enjoy the vibrant social scene around the pool as part of the excellent lifestyle amenities we provide. Choose from our spacious one- and two-bedroom apartments, all designed to complement your modern living needs while enjoying the fun of poolside relaxation.\n\nLocated in Northeast Wichita, Remington Wichita boasts easy access to local attractions and quick commutes via I-35. Beyond our refreshing outdoor pool, enjoy the convenience of online rental payments and the option of private patios or balconies, enhancing your living experience in Sedgwick County. Experience the perfect blend of leisure and convenience right at your doorstep, ensuring every day feels like a vacation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
      "featured_image_media": {
        "alt_text": "The Remington Apartments logo",
        "public_id": "019cfb4e-be95-73eb-98fe-0635e230a873",
        "storage_key": "property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
        "width": 1500,
        "height": 357
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in Sedgwick County",
      "seo_description": "Discover Remington Wichita, offering apartments with a refreshing pool in Sedgwick County. Enjoy spacious living and top-notch amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "generator",
      "page_item_url": "spacious-floor-plans-northeast-wichita",
      "search_query": "spacious floor plans northeast wichita",
      "category": "Amenity",
      "h1_title": "Spacious Floor Plans in Northeast Wichita",
      "h2_subtitle": "Explore flexible living at Remington Wichita. Discover our spacious floor plans perfect for a modern lifestyle in Northeast Wichita.",
      "page_copy": "At Remington Wichita, spacious floor plans in Northeast Wichita await you. Our expansive one- and two-bedroom layouts offer ample room for all your needs, whether you're working from home or hosting a cozy gathering. Nestled in Northeast Wichita, our community provides a harmonious blend of convenience and comfort designed to enhance your lifestyle.\n\nResidents enjoy the added benefits of private patios or balconies, ideal for relaxing afternoons. With swift access to I-35, our location ensures you are always connected to the city's vibrant scene. Coupled with modern amenities like high-speed internet and online rental payments, Remington Wichita is truly designed for contemporary living in Northeast Wichita.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
      "featured_image_media": {
        "alt_text": "The Remington Apartments logo",
        "public_id": "019cfb4e-be95-73eb-98fe-0635e230a873",
        "storage_key": "property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
        "width": 1500,
        "height": 357
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Floor Plans in Northeast Wichita",
      "seo_description": "Discover spacious floor plans at Remington Wichita, ideal for modern living. Located in vibrant Northeast Wichita with great access and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-67226",
      "search_query": "fitness center apartments 67226",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in 67226",
      "h2_subtitle": "Enhance your lifestyle at Remington Wichita. Experience vibrant living at apartments with access to fitness centers in the 67226 area.",
      "page_copy": "While Remington Wichita doesn't feature an on-site fitness center, residents enjoy a variety of active lifestyle options close by in the 67226 area. This strategic location in Northeast Wichita means you're only moments away from local gyms and fitness hubs that cater to every kind of workout style. Our community caters to modern living needs, with easy access to I-35 allowing quick commutes for those keen on maintaining an active schedule.\n\nBeyond nearby fitness facilities, Remington Wichita offers spacious one- and two-bedroom floor plans that provide ample space for at-home workouts. Enjoy peace of mind with our pet-friendly environment, a beautiful outdoor swimming pool, and private patios or balconies, making it easy to find the balance between work, relaxation, and fitness in the vibrant 67226 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
      "featured_image_media": {
        "alt_text": "The Remington Apartments logo",
        "public_id": "019cfb4e-be95-73eb-98fe-0635e230a873",
        "storage_key": "property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
        "width": 1500,
        "height": 357
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in 67226",
      "seo_description": "Explore Remington Wichita for flexible living. Close to fitness centers and offering spacious apartments in the vibrant 67226 area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "generator",
      "page_item_url": "apartments-washer-dryer-connections-wichita",
      "search_query": "apartments with washer dryer connections wichita",
      "category": "Amenity",
      "h1_title": "Apartments with Washer Dryer Connections",
      "h2_subtitle": "Discover the convenience at Remington Wichita. Enjoy apartments with washer dryer connections ideal for modern living in Wichita.",
      "page_copy": "At Remington Wichita, we prioritize convenience and modern living, offering apartments with the flexibility of washer dryer connections. Located in the vibrant heart of Wichita, our community invites you to experience the ease of having in-home laundry facilities in our spacious one- and two-bedroom floor plans. This feature allows you to streamline your daily routine and enjoy more free time in our vibrant neighborhood.\n\nBeyond the convenience of washer dryer connections, Remington Wichita offers residents access to a variety of top-notch amenities, including a refreshing outdoor pool and private patios or balconies. Nestled in Northeast Wichita with easy access to I-35, you'll find the perfect blend of comfort and connectivity, making it simple to balance work, leisure, and home all in one vibrant location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
      "featured_image_media": {
        "alt_text": "The Remington Apartments logo",
        "public_id": "019cfb4e-be95-73eb-98fe-0635e230a873",
        "storage_key": "property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
        "width": 1500,
        "height": 357
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Washer Dryer Connections",
      "seo_description": "Discover Remington Wichita's convenient living with washer dryer connections in spacious apartments. Enjoy modern amenities in central Wichita.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-northeast-wichita",
      "search_query": "one bedroom apartments northeast wichita",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Northeast Wichita",
      "h2_subtitle": "Explore stylish one-bedroom apartments at Remington Wichita. Live comfortably in Northeast Wichita's vibrant community.",
      "page_copy": "Remington Wichita invites you to discover the charm of our one-bedroom apartments in Northeast Wichita. Perfect for those seeking a balance of comfort and style, these spacious and thoughtfully designed residences offer the ideal retreat. Our community is conveniently located, granting you easy access to I-35, ensuring swift commutes and connectivity to the best of Wichita.\n\nEach one-bedroom apartment features modern amenities designed to enhance your daily life, such as private patios or balconies and high-speed AT&T internet. Take advantage of community benefits like our outdoor swimming pool and BBQ picnic area, making socializing and relaxation easy. Experience the vibrant living at Remington Wichita, where one-bedroom options are crafted to meet the demands of modern lifestyles in Northeast Wichita.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
      "featured_image_media": {
        "alt_text": "The Remington Apartments logo",
        "public_id": "019cfb4e-be95-73eb-98fe-0635e230a873",
        "storage_key": "property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
        "width": 1500,
        "height": 357
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Northeast Wichita",
      "seo_description": "Discover modern one-bedroom apartments in Northeast Wichita. Enjoy vibrant living with great amenities at Remington Wichita.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-sedgwick-county",
      "search_query": "two bedroom apartments sedgwick county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Sedgwick County",
      "h2_subtitle": "Find spacious two-bedroom apartments at Remington Wichita. Enjoy modern living in Sedgwick County's thriving community.",
      "page_copy": "Discover the perfect home for dynamic living in Sedgwick County with Remington Wichita's two-bedroom apartments. These thoughtfully crafted units offer ample space and comfort, tailored to modern families or roommates seeking an enhanced living experience. Enjoy the convenience of easy access to I-35, connecting you to all the attractions and necessities around Wichita.\n\nOur two-bedroom apartments come equipped with desirable amenities, including high-speed internet options and private patios or balconies that provide a personal outdoor space. As part of the Remington Wichita community, residents also have access to an inviting outdoor pool and a BBQ picnic area, perfect for enjoying sunny days. Whether you're looking to relax or entertain, our two-bedroom options in Sedgwick County cater to a well-balanced lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
      "featured_image_media": {
        "alt_text": "The Remington Apartments logo",
        "public_id": "019cfb4e-be95-73eb-98fe-0635e230a873",
        "storage_key": "property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
        "width": 1500,
        "height": 357
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Sedgwick County",
      "seo_description": "Explore spacious two-bedroom apartments in Sedgwick County at Remington Wichita. Enjoy modern living with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "generator",
      "page_item_url": "apartments-near-wichita-state-university",
      "search_query": "apartments near wichita state university",
      "category": "School",
      "h1_title": "Apartments Near Wichita State University",
      "h2_subtitle": "Live conveniently at Remington Wichita, near Wichita State University. Enjoy spacious floor plans and modern amenities in a vibrant community.",
      "page_copy": "For students and faculty seeking proximity to Wichita State University, Remington Wichita offers the perfect apartment options. Our community is strategically located, providing a short commute to the campus while offering the comfort and tranquility of a residential setting in Northeast Wichita. Experience the balance of study, work, and leisure in our one- and two-bedroom apartments designed for contemporary living.\n\nResidents enjoy a host of amenities, from high-speed internet powered by AT&T to private patios or balconies for relaxation. The community features an outdoor pool and BBQ picnic area, ideal for mingling with neighbors or unwinding after a day of classes. Remington Wichita combines convenience with a friendly atmosphere, making it an excellent choice for those connected to Wichita State University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
      "featured_image_media": {
        "alt_text": "The Remington Apartments logo",
        "public_id": "019cfb4e-be95-73eb-98fe-0635e230a873",
        "storage_key": "property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
        "width": 1500,
        "height": 357
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wichita State University",
      "seo_description": "Find modern apartments near Wichita State University at Remington Wichita. Enjoy convenience and top amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "generator",
      "page_item_url": "remington-apartments-by-woolsey-hall-wichita",
      "search_query": "remington apartments by woolsey hall wichita",
      "category": "School",
      "h1_title": "Remington Apartments Near Woolsey Hall",
      "h2_subtitle": "Discover convenient living at Remington Apartments, just moments from Woolsey Hall. Enjoy a vibrant lifestyle in Wichita's dynamic community.",
      "page_copy": "Remington Wichita provides an ideal living environment for those seeking proximity to Woolsey Hall. Situated in Northeast Wichita, our community offers seamless access to academic and cultural activities, making it a prime choice for students and professionals alike. Enjoy living in well-designed one- and two-bedroom apartments that meet the demands of modern lifestyles.\n\nOur residents benefit from a wide range of amenities, including fast AT&T internet connections and private outdoor spaces like patios or balconies. Socialize and relax by the outdoor pool or enjoy a meal in our designated BBQ picnic area. Positioned near Woolsey Hall, Remington Wichita combines convenience with comfort, creating a balanced living experience in the heart of Wichita.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
      "featured_image_media": {
        "alt_text": "The Remington Apartments logo",
        "public_id": "019cfb4e-be95-73eb-98fe-0635e230a873",
        "storage_key": "property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
        "width": 1500,
        "height": 357
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Remington Apartments Near Woolsey Hall",
      "seo_description": "Explore Remington Apartments by Woolsey Hall in Wichita. Enjoy convenient living in spacious apartments with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "generator",
      "page_item_url": "apartments-near-wesley-medical-center-wichita-ks",
      "search_query": "apartments near Wesley Medical Center Wichita KS",
      "category": "Hospital",
      "h1_title": "Apartments Near Wesley Medical Center Wichita",
      "h2_subtitle": "Find the ideal home at Remington Wichita, located conveniently near Wesley Medical Center. Enjoy comfort and modern amenities in a vibrant community.",
      "page_copy": "For healthcare professionals and visitors seeking proximity to Wesley Medical Center in Wichita, KS, Remington Wichita offers ideal living options. Located a short drive away, our community provides easy access to the medical center without compromising on comfort and tranquility. Choose from our spacious one- and two-bedroom apartments tailored for those who desire modern living in a convenient location.\n\nAt Remington Wichita, residents benefit from high-speed internet and private outdoor spaces, ensuring both connectivity and personal relaxation. Whether you're savoring a sunny day by the outdoor pool or using the BBQ picnic area for gatherings, the amenities foster a balanced lifestyle. Living near Wesley Medical Center has never been more accommodating than at Remington Wichita.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
      "featured_image_media": {
        "alt_text": "The Remington Apartments logo",
        "public_id": "019cfb4e-be95-73eb-98fe-0635e230a873",
        "storage_key": "property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
        "width": 1500,
        "height": 357
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wesley Medical Center Wichita",
      "seo_description": "Discover apartments near Wesley Medical Center in Wichita KS at Remington Wichita. Enjoy modern living close to healthcare and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "generator",
      "page_item_url": "apartments-close-to-ascension-via-christi-st-francis-sedgwick-county",
      "search_query": "apartments close to Ascension Via Christi St. Francis Sedgwick County",
      "category": "Hospital",
      "h1_title": "Apartments Near Ascension Via Christi St. Francis",
      "h2_subtitle": "Remington Wichita offers apartments close to Ascension Via Christi St. Francis in Sedgwick County. Experience convenient and comfortable living.",
      "page_copy": "If you're searching for a home close to Ascension Via Christi St. Francis in Sedgwick County, Remington Wichita is the ideal choice. Our community provides a peaceful retreat with convenient access to this major healthcare facility, making it perfect for professionals and patients alike. Choose from our well-appointed one- and two-bedroom floor plans, designed to cater to modern needs.\n\nResidents at Remington Wichita enjoy an array of premium amenities, including high-speed internet from AT&T and private patios or balconies. Unwind by the outdoor swimming pool or host gatherings at the BBQ picnic area. Positioned conveniently near Ascension Via Christi St. Francis, our community combines a supportive environment with modern conveniences, enhancing both work and lifestyle balance in Wichita.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
      "featured_image_media": {
        "alt_text": "The Remington Apartments logo",
        "public_id": "019cfb4e-be95-73eb-98fe-0635e230a873",
        "storage_key": "property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
        "width": 1500,
        "height": 357
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ascension Via Christi St. Francis",
      "seo_description": "Find apartments close to Ascension Via Christi St. Francis in Sedgwick County with Remington Wichita. Conveniently located modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "generator",
      "page_item_url": "apartments-near-great-plains-nature-center-wichita-ks",
      "search_query": "apartments near great plains nature center wichita ks",
      "category": "Park",
      "h1_title": "Apartments Near Great Plains Nature Center",
      "h2_subtitle": "Experience nature at its best with Remington Wichita, ideally located near the Great Plains Nature Center in Wichita, KS. Live close to natural tranquility.",
      "page_copy": "For nature enthusiasts, finding a home near the Great Plains Nature Center in Wichita, KS, is a dream come true with Remington Wichita. Our community offers not only convenient access to this natural haven but also a blend of comfort and modern living. Enjoy spacious one- and two-bedroom apartments tailored to meet the needs of a dynamic lifestyle while being close to soothing green spaces.\n\nRemington Wichita boasts a range of amenities that complement outdoor living, such as a refreshing swimming pool and a picturesque BBQ picnic area. Residents can stay connected with fast AT&T internet and relax on private patios or balconies. Just a stone’s throw from the Great Plains Nature Center, Remington Wichita provides a perfect balance between urban convenience and serene natural surroundings.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
      "featured_image_media": {
        "alt_text": "The Remington Apartments logo",
        "public_id": "019cfb4e-be95-73eb-98fe-0635e230a873",
        "storage_key": "property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
        "width": 1500,
        "height": 357
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Great Plains Nature Center",
      "seo_description": "Discover apartments near Great Plains Nature Center in Wichita, KS at Remington Wichita. Enjoy modern living close to nature's beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "generator",
      "page_item_url": "northeast-wichita-apartments-close-to-fairmount-park",
      "search_query": "northeast wichita apartments close to fairmount park",
      "category": "Park",
      "h1_title": "Northeast Wichita Apartments Near Fairmount Park",
      "h2_subtitle": "Discover the perfect blend of comfort and leisure at Remington Wichita, located in Northeast Wichita, close to Fairmount Park. Enjoy vibrant community living.",
      "page_copy": "Settle into the charm of Northeast Wichita at Remington Wichita, where proximity to Fairmount Park offers unparalleled recreational opportunities right at your doorstep. Our vibrant community offers spacious one- and two-bedroom apartments, designed with modern conveniences to cater to your lifestyle needs. Whether you're a park enthusiast or seeking a peaceful retreat, our location is ideal.\n\nResidents of Remington Wichita benefit from top-tier amenities, including fast internet powered by AT&T, making it easy to work from home. Enjoy sunny days by our outdoor pool or host friends at the BBQ picnic area. Located close to Fairmount Park, it's easy to enjoy both active and relaxing pursuits, making Remington Wichita the perfect home base in Northeast Wichita.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
      "featured_image_media": {
        "alt_text": "The Remington Apartments logo",
        "public_id": "019cfb4e-be95-73eb-98fe-0635e230a873",
        "storage_key": "property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
        "width": 1500,
        "height": 357
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Northeast Wichita Apartments Near Fairmount Park",
      "seo_description": "Find Northeast Wichita apartments near Fairmount Park at Remington Wichita. Experience modern living in a community close to nature and urban amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "generator",
      "page_item_url": "sedgwick-county-apartments-by-edgemoor-park",
      "search_query": "sedgwick county apartments by edgemoor park",
      "category": "Park",
      "h1_title": "Sedgwick County Apartments by Edgemoor Park",
      "h2_subtitle": "Enjoy the best of Sedgwick County living at Remington Wichita, nestled near Edgemoor Park. Discover a community designed for comfort and convenience.",
      "page_copy": "Discover your ideal home at Remington Wichita, strategically positioned in Sedgwick County near the serene Edgemoor Park. Our community offers an array of spacious one- and two-bedroom apartment options perfect for those who value both comfort and location. Enjoy easy access to the lush landscapes of Edgemoor Park, ideal for leisurely walks and vibrant community activities.\n\nLiving at Remington Wichita means indulging in a lifestyle filled with modern amenities like super-fast AT&T internet, a refreshing outdoor swimming pool, and a welcoming BBQ picnic area. Each apartment features a private patio or balcony, enhancing your living experience. Whether you're a nature lover or a city dweller, our location near Edgemoor Park perfectly balances tranquility and city conveniences.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
      "featured_image_media": {
        "alt_text": "The Remington Apartments logo",
        "public_id": "019cfb4e-be95-73eb-98fe-0635e230a873",
        "storage_key": "property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
        "width": 1500,
        "height": 357
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sedgwick County Apartments by Edgemoor Park",
      "seo_description": "Explore Sedgwick County apartments by Edgemoor Park at Remington Wichita. Enjoy modern amenities and a prime location near natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166548",
      "source": "generator",
      "page_item_url": "apartment-living-near-eastborough-park-wichita-67226",
      "search_query": "apartment living near eastborough park wichita 67226",
      "category": "Park",
      "h1_title": "Apartment Living Near Eastborough Park",
      "h2_subtitle": "Discover contemporary apartment living near Eastborough Park at Remington Wichita. Enjoy a blend of nature and city amenities in the 67226 area.",
      "page_copy": "Experience the perfect blend of nature and modern comforts at Remington Wichita, located near Eastborough Park in the vibrant 67226 area. Our community offers spacious one- and two-bedroom apartments ideal for those seeking convenience and stylish living. With Eastborough Park just minutes away, immerse yourself in outdoor activities or enjoy a quiet stroll.\n\nAt Remington Wichita, amenities such as high-speed internet by AT&T, a sparkling swimming pool, and a charming BBQ picnic area come standard. These features, along with private patios or balconies, make for an unparalleled living experience. Embrace a community where nature meets city living, providing you the finest apartment lifestyle near Eastborough Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
      "featured_image_media": {
        "alt_text": "The Remington Apartments logo",
        "public_id": "019cfb4e-be95-73eb-98fe-0635e230a873",
        "storage_key": "property/6767906449166548/019cfb4e-be95-73eb-98fe-0635e230a873.webp",
        "width": 1500,
        "height": 357
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Living Near Eastborough Park",
      "seo_description": "Enjoy apartment living near Eastborough Park in Wichita 67226 at Remington Wichita. Experience nature and comfort in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5207"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-FHW9W67FJG"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18128852709"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/the-remington/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N2CKSR7J"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d1bd6-182e-739f-80fa-e10af7474fd0.webp"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "6c82a7d1-19fe-4056-9b7b-2497ac8e17a5"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-433-4920"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "650082acc6c185bbb9abb3d6"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im1BY002RDBpY2E1a0pkdVYvRjN4OFE9PSIsInZhbHVlIjoicE9RR0J6NnZJZlhCY3pNMDV3NlFFUT09IiwibWFjIjoiOTlkMTdlNGI0ZTVmNWVkOTQ3M2Q5MTIxODY2N2VmMzljODE1YmQ5ZTVhN2QzNTAwOTdmOGQwNzMwMGRiMGU0YyJ9"
    }
  ],
  "custom_qb_id": "5207",
  "custom_ga4_id": "G-FHW9W67FJG",
  "custom_repli_id": "18128852709",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/the-remington/register/",
  "custom_google_gtm_id": "GTM-N2CKSR7J",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019d1bd6-182e-739f-80fa-e10af7474fd0.webp",
  "custom_rentgrata_property_id": "6c82a7d1-19fe-4056-9b7b-2497ac8e17a5",
  "custom_ppc_tracking_phone_number": "844-433-4920",
  "custom_residentboost_apartment_id": "650082acc6c185bbb9abb3d6",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im1BY002RDBpY2E1a0pkdVYvRjN4OFE9PSIsInZhbHVlIjoicE9RR0J6NnZJZlhCY3pNMDV3NlFFUT09IiwibWFjIjoiOTlkMTdlNGI0ZTVmNWVkOTQ3M2Q5MTIxODY2N2VmMzljODE1YmQ5ZTVhN2QzNTAwOTdmOGQwNzMwMGRiMGU0YyJ9"
};

export const generatedAt = '2026-08-27T21:34:06.356Z';
